<template>
	<div class="margin_projet">
		<div>
			<a
				v-if="config"
				class="info"
				v-show="state == 'configuration'"
				href="https://docs.smartmydata.com/editeur_de_scenarios/accueil-configuration.html"
				target="_blank"
				><i class="fas fa-info-circle"></i></a
			>
			<a
				v-if="config"
				class="info"
				v-show="state == 'données'"
				href="https://docs.smartmydata.com/editeur_de_scenarios/data.html"
				target="_blank"
				><i class="fas fa-info-circle"></i
			></a>

			<a
				v-if="config"
				v-show="state == 'etape'"
				href="https://docs.smartmydata.com/editeur_de_scenarios/scenario.html"
				target="_blank"
				><i class="fas fa-info-circle"></i
			></a>
		</div>
		<div>
			<notifications position="top center" group="info" />

			<div v-show="state == 'configuration' || state == 'données'">
				<h6 v-if="config || config_name">Scenario {{ name }}</h6>

				<b-button
					class="bouton"
					:variant="
						state == 'configuration' ? 'primary' : 'secondary'
					"
					@click="set_state('configuration')"
					><i class="fas fa-cogs"></i></b-button
				>&nbsp;
				<b-button
					class="bouton"
					:variant="state == 'données' ? 'primary' : 'secondary'"
					@click="set_state('données')"
					><i class="fas fa-file-alt"> data</i></b-button
				>&nbsp;
				<b-button
					class="bouton"
					:variant="state == 'etape' ? 'primary' : 'secondary'"
					@click="
						set_state('etape');
						if (project_v2 && view_step.length === 0) {
							toggleActionChoice(true);
						}
					"
					><i class="fas fa-list"> étapes</i></b-button
				>&nbsp;
				<b-button
					v-if="config"
					class="bouton"
					v-show="name && version"
					:variant="'secondary'"
					@click="save_db(false, false)"
					><i class="fas fa-save"></i
				></b-button>

				<br /><br />
			</div>

			<div v-show="state == 'configuration'">
				<b-tabs v-model="config_index" content-class="mt-3">
					<b-tab v-if="config" title="Charger">
						<span>Nom</span>
						<v-select
							v-model="load_name"
							:options="list_name"
							label="text"
							:reduce="(option) => option.value"></v-select>
						<span>Version</span>
						<v-select
							label="text"
							:reduce="(option) => option.value"
							v-model="load_version"
							:options="list_version"></v-select>
						<br /><br />
						<b-button v-on:click="load_db()">Charger</b-button>
						<br /><br />
						<b-form-file
							accept=".json"
							@change="load_file"
							placeholder="charger depuis un fichier"></b-form-file>
						<br /><br />
						<b-button v-b-toggle="'list' + id">Liste des scénarios</b-button>&nbsp;
						<b-button @click="zip">Zip des scénarios</b-button>
						<b-collapse :id="'list' + id">
							<div v-for="(scenario, idx) in list_name" :key="idx">
								<p><router-link
									:to="{ name: 'project_v1', params: { id: scenario.uid } }"
									>{{scenario.text}}</router-link><br />
								<span style="white-space: pre-wrap;" v-if="scenario.description">{{scenario.description}}</span></p>
							</div>
						</b-collapse>
					</b-tab>

					<b-tab title="Scénario">
						<div v-if="config">
							<span>Nom</span>
							<b-form-input v-model="name"></b-form-input>
							<span>Version</span>
							<b-form-input
								v-on:update="update_version"
								v-model="version"></b-form-input>
							<span>Description du projet</span>
							<b-textarea
								v-model="description_project"
								rows="5"></b-textarea>
							<div v-if="_canGenerateIa" class="d-flex align-items-center mt-1">
							<b-button 
								@click="generate_project_description" 
								:disabled="generating_project_description || !name"
								variant="link" class="p-0">
								<i class="fas fa-robot"></i> Générer la description du projet
							</b-button>
							<b-button variant="link" class="p-0 ml-3 text-muted" @click="toggle_custom_prompt_project">
								<i class="fas fa-sliders-h"></i>
								{{ show_custom_prompt_project ? 'Masquer le prompt' : 'Personnaliser le prompt' }}
							</b-button>
							<b-button v-if="custom_prompt_project" variant="link" class="p-0 ml-2 text-danger" title="Réinitialiser le prompt" @click="reset_custom_prompt_project">
								<i class="fas fa-undo"></i>
							</b-button>
						</div>
						<b-collapse v-if="_canGenerateIa" v-model="show_custom_prompt_project">
							<div class="mt-2 p-2 border rounded bg-light">
								<small class="text-muted d-block mb-1">Début du prompt envoyé à l'IA — les données du scénario sont toujours ajoutées à la suite.</small>
								<b-textarea v-model="custom_prompt_project" rows="10" />
							</div>
						</b-collapse>
						<div v-if="generating_project_description" class="mt-2">
							<b-spinner small></b-spinner>
							<small class="ml-2">Génération en cours...</small>
						</div>
							<b-button v-b-modal="'modal-descriptions' + id" variant="link" class="mt-2">
								<i class="fas fa-edit"></i> Description courte et commentaire
							</b-button>
							<b-modal
								:id="'modal-descriptions' + id"
								title="Description courte et commentaire"
								size="lg"
								hide-footer>
								<span>Description courte du projet</span>
								<b-textarea
									v-model="short_description_project"
									rows="5"></b-textarea>
								<br />
								<span>Commentaire du projet</span>
								<b-textarea
									v-model="comment_project"
									rows="5"></b-textarea>
							</b-modal>
							<br />
							<span>Description de la version</span>
							<b-textarea
								v-model="description"
								rows="5"></b-textarea>
							<div v-if="list_version">
								<br />
								<b-button v-b-toggle="'list-version' + id">Historique des versions</b-button>
								<b-collapse :id="'list-version' + id">
									<div v-for="(version, idx) in list_version" :key="idx">
										<p><u>{{version.text}}</u><br />
										<span style="white-space: pre-wrap;">{{version.description}}</span>
										</p>
									</div>
								</b-collapse>
							</div>
							<p v-if="prod_version">
								Version active pour les traitements :
								{{ prod_version }}
							</p>
							<br />
							<b-button 
								v-b-modal="'modal-all-steps-descriptions'"
								:disabled="steps.length === 0"
								variant="link">
								<i class="fas fa-list-ul"></i> Voir toutes les descriptions
							</b-button>
							<b-button 
								@click="generate_all_descriptions" 
								:disabled="generating_descriptions || steps.length === 0"
								variant="link">
								<i class="fas fa-robot"></i> Générer toutes les descriptions des étapes
							</b-button>
							<b-form-checkbox 
								v-model="generate_only_empty_descriptions"
								class="ml-2 d-inline-block">
								Uniquement les étapes vides
							</b-form-checkbox>

						<div v-if="generating_descriptions" class="mt-2">
							<b-progress :value="description_progress" :max="steps.length" animated>
								<b-progress-bar :value="description_progress" :max="steps.length">
									{{ Math.round((description_progress / steps.length) * 100) }}%
								</b-progress-bar>
							</b-progress>
							<small>Génération en cours : étape {{ description_current }} sur {{ steps.length }}</small>
						</div>

						<b-modal
							:id="'modal-all-steps-descriptions'"
							title="Descriptions et commentaires des étapes"
							size="xl"
							hide-footer>
							<div v-if="steps.length === 0" class="text-center text-muted">
								Aucune étape dans le scénario
							</div>
							<div v-else>
								<div v-for="(step, idx) in steps" :key="step.id" class="mb-4 pb-3 border-bottom">
									<h5>
										<span class="badge badge-primary mr-2">{{ idx + 1 }}</span>
										{{ get_step_info(step.id).description || get_step_info(step.id).action_label || step.data.action || 'Action non définie' }}
									</h5>
									<div v-if="get_step_info(step.id).comment" class="mb-2">
										<strong><i class="fas fa-comment"></i> Commentaire :</strong>
										<p class="ml-3 mb-0" style="white-space: pre-wrap;">{{ get_step_info(step.id).comment }}</p>
									</div>
									<div v-if="get_step_info(step.id).long_description" class="mb-2">
										<strong><i class="fas fa-align-left"></i> Description :</strong>
										<p class="ml-3 mb-0" style="white-space: pre-wrap;">{{ get_step_info(step.id).long_description }}</p>
									</div>
									<div v-if="!get_step_info(step.id).comment && !get_step_info(step.id).long_description" class="text-muted ml-3">
										<em>Aucune description ou commentaire</em>
									</div>
								</div>
							</div>
						</b-modal>

							<hr />

							<div class="flex" v-if="!user.env">
								<div
									class="mr-2"
									:class="version_prod ? 'opacity-25' : ''">
									Test
								</div>
								<b-form-checkbox
									switch
									v-model="version_prod"
									:disabled="prod_version ? false : true">
								</b-form-checkbox>
								<div :class="!version_prod ? 'opacity-25' : ''">
									Actif
								</div>
							</div>
							<div class="flex" v-if="user.env">
								<div
									class="mr-2"
									:class="version_env ? 'opacity-25' : ''">
									Test
								</div>
								<b-form-checkbox
									switch
									v-model="version_env"
									:disabled="prod_version ? false : true">
								</b-form-checkbox>
								<div :class="!version_env ? 'opacity-25' : ''">
									Actif
								</div>
							</div>

							<p v-if="!prod_version">
								Ne peut être mis en test car actif
							</p>


							<p>
								Traitement par lots
								<b-select v-model="lines_mode" :options="[
									{value: false, text: 'Désactivé'},
									{value: true, text: 'Activé'},
									{value: 'steps', text: 'Certaines étapes'},
								]" />

								<div>
									Nombres de lignes par lot
									<b-input type="number" :min="1" step="1" v-model="lines_nb"></b-input>
								</div>
							</p>


							<div>
								<span
									>Apparaît dans la liste de création de
									traitements</span
								>
								<b-form-checkbox
									v-model="
										inDropdownTraitements
									"></b-form-checkbox>
							</div>
							<br />
							<div>
								<span
									>Apparaît dans la liste des pré/post traitements des documents</span
								>
								<b-form-checkbox
									v-model="
										inDropdownPostTreatments
									"></b-form-checkbox>
							</div>
							<br />
							<div>
								<b-button v-b-modal="'modal-project-env'"
									>Autres environnements</b-button
								>
							</div>

							<b-modal
								:hide-footer="true"
								:id="'modal-project-env'"
								title="Autres environnements à mettre en actif">
								<b-input-group>
									<b-form-checkbox-group
										id="boxes"
										v-model="sync_env"
										:options="env_list"
										name="boxes"
										stacked />
								</b-input-group>
							</b-modal>
							<br />
							<div>
								<span>Visualiation automatique des fichiers</span>
								<b-form-checkbox v-model="render_files"></b-form-checkbox>
							</div>
							<br />
							<div>
								<span>Si possible, test avec le navigateur</span>
								<b-form-checkbox v-model="browser"></b-form-checkbox>
							</div>
							<br />
							<div>
								<span>Sous traitement</span>
								<b-form-checkbox v-model="sub_treatment"></b-form-checkbox>
							</div>
							<br />
							<div>
								<span>Traitements suivants</span>
								<b-select :options="projects_options" v-model="next_treatments" multiple :select-size="10"></b-select>
							</div>
						</div>
						<div v-else>
							<span>Nom : {{ name }}</span>
							<br />
							<span>Version : {{ version }}</span>
						</div>

					</b-tab>

					<b-tab v-if="config" title="Sauvegarder">
						<span>Nom</span>
						<b-form-input v-model="name"></b-form-input>
						<span>Version</span>
						<b-form-input v-model="next_version"></b-form-input>
						<b-button class="mt-3" v-on:click="save_db()"
							>Enregistrer</b-button
						>
						<br /><br />
						<b-button v-on:click="save()"
							>Enregistrer dans un fichier</b-button
						><br /><br />
						<div v-if="save_exist">
							Ce scénario avec cette version existe déjà, cette
							sauvegarde va la remplacer
							<b-button
								variant="danger"
								v-on:click="save_db(false)"
								>Confirmer</b-button
							>
						</div>
					</b-tab>

					<!-- <b-tab v-show="config" title="Projet">
            <p>Sélectionnner un projet</p>
            <b-form-select
              @change="setProject()"
              v-model="project"
              :options="projects_options"
              :value="project"
            />
          </b-tab> -->

					<b-tab v-show="config" title="Tags">
						<div :id="'jsoneditor-' + id"></div>
					</b-tab>

					<b-tab v-show="config" title="Tests">
						<b-container
							style="margin: 0; padding: 0; max-width: none">
							<b-row
								ref="div_row_test"
								style="margin: 0; padding: 0; max-width: none">
								<b-col
									ref="div_menu_test"
									md="auto"
									style="
										margin: 0;
										padding: 0;
										max-width: none;
									">
									<b-button
										class="bouton"
										variant="link"
										@click="set_state_test('configuration')"
										>Configuration</b-button
									>
									<div>
										Tests
										<b-button
											class="bouton"
											variant="link"
											@click="add_test()"
											>+</b-button
										>
									</div>
									<div
										v-for="test in tests.tests"
										:key="test.uid">
										<b-button
											:style="
												'color: ' +
												(test.color
													? test.color
													: 'black')
											"
											class="bouton"
											variant="link"
											@click="set_state_test(test.uid)"
											>{{ test.name }}</b-button
										>
									</div>
								</b-col>
								<b-col
									:style="
										'max-width: ' + (size_test - 100) + 'px'
									">
									<div v-show="state_test == 'configuration'">
										<div>Configuration</div>
										<br />
										<div
											v-for="(element, idx) in steps"
											:key="element.id">
											<span>
												<b-form-checkbox
													v-model="element.test"
													:value="true"
													:unchecked-value="false">
													{{ idx + 1 }} -
													{{
														element.description !=
														undefined
															? element.description
																	.substring(
																		0,
																		element.description.indexOf(
																			"."
																		)
																	)
																	.substring(
																		0,
																		30
																	) ||
															  element.description.substring(
																	0,
																	30
															  ) ||
															  element.data
																	.label ||
															  "nouvelle étape"
															: "nouvelle étape"
													}}{{
														element.description
															? element
																	.description
																	.length > 30
																? "..."
																: ""
															: ""
													}}
												</b-form-checkbox>
											</span>
										</div>
										<br />
										<div>
											<b-form-checkbox
												v-model="
													tests.configuration.end
												"
												:value="true"
												:unchecked-value="false"
												>Fichier final</b-form-checkbox
											>
										</div>
									</div>
									<div
										v-for="(test, idx) in tests.tests"
										:key="test.uid">
										<div v-show="state_test == test.uid">
											<b-input
												v-model="test.name"></b-input>
											<br />
											<b-button @click="set_test(idx)"
												><i
													class="fas fa-camera"></i></b-button
											>&nbsp;
											<b-button @click="start_test(idx)"
												><i class="fas fa-play"></i
											></b-button>
											<br /><br />
											<p>Données initiales</p>
											<edit_tabulator
												:columns_type="tabulator_columns_type"
												:extern_file="false"
												:ref="
													'tabulator' + idx
												"></edit_tabulator>
											<br />
											<div
												v-for="step in test.steps"
												:key="step.uid">
												<div>
													<b
														>{{
															step.step
																.description !=
															undefined
																? step.step.description
																		.substring(
																			0,
																			step.step.description.indexOf(
																				"."
																			)
																		)
																		.substring(
																			0,
																			30
																		) ||
																  step.step.description.substring(
																		0,
																		30
																  ) ||
																  step.step.data
																		.label ||
																  "nouvelle étape"
																: "nouvelle étape"
														}}{{
															step.step
																.description
																? step.step
																		.description
																		.length >
																  30
																	? "..."
																	: ""
																: ""
														}}</b
													>
												</div>
												<p>Test</p>
												<edit_tabulator
													:columns_type="tabulator_columns_type"
													:extern_file="false"
													:ref="
														'tabulator' +
														idx +
														step.step.data.uid
													"></edit_tabulator>
												<p>Résultat</p>
												<edit_tabulator
													:columns_type="tabulator_columns_type"
													:extern_file="false"
													:ref="
														'tabulator' +
														idx +
														step.step.data.uid +
														'result'
													"></edit_tabulator>
												<div v-show="step.diff">
													<div
														v-if="
															step.diff &&
															step.diff
																.nb_lines != 0
														">
														Nombres de lignes en
														{{
															step.diff.nb_lines >
															0
																? "moins"
																: "plus"
														}}
														:
														{{
															step.diff.nb_lines >
															0
																? step.diff
																		.nb_lines
																: -step.diff
																		.nb_lines
														}}
													</div>
													<div
														v-if="
															step.diff &&
															step.diff
																.columns_less &&
															step.diff
																.columns_less
																.length > 0
														">
														Colonnes en moins :
														{{
															step.diff.columns_less.join(
																", "
															)
														}}
													</div>
													<div
														v-if="
															step.diff &&
															step.diff
																.columns_more &&
															step.diff
																.columns_more
																.length > 0
														">
														Colonnes en plus :
														{{
															step.diff.columns_more.join(
																", "
															)
														}}
													</div>
													<div
														v-show="
															step.diff &&
															step.diff.data &&
															step.diff.data
																.length > 0
														">
														Différences
													</div>
													<edit_tabulator
														:columns_type="tabulator_columns_type"
														v-show="
															step.diff &&
															step.diff.data &&
															step.diff.data
																.length > 0
														"
														:extern_file="false"
														:ref="
															'tabulator' +
															idx +
															step.step.data.uid +
															'diff'
														"></edit_tabulator>
													<br />
												</div>
											</div>
											<i
												class="fa fa-times close"
												@click="removeTestAt(idx)"></i>
										</div>
									</div>
								</b-col>
							</b-row>
						</b-container>
					</b-tab>

					<b-tab v-show="config" title="Boutons d'action">
						<div :id="'jsoneditor-action-' + id"></div>
					</b-tab>

					<b-tab v-if="config" title="Renommer">
						<p>Nom actuel : {{ name }}</p>
						<span>Nouveau nom</span>
						<b-form-input v-model="new_name"></b-form-input>
						<br />
						<b-button v-on:click="rename()">Renommer</b-button>
					</b-tab>

					<b-tab v-if="config" title="Archiver">
<div class="mt-2 mb-3 d-flex align-items-center" style="gap: 0.75rem;">
					<b-button-group size="sm">
						<b-button
							:variant="archive_filter === 'all' ? 'primary' : 'outline-secondary'"
							@click="archive_filter = 'all'"
						>Tous ({{ list_projects.length + list_projects_archive.length }})</b-button>
						<b-button
							:variant="archive_filter === 'active' ? 'success' : 'outline-secondary'"
							@click="archive_filter = 'active'"
						>Actifs ({{ list_projects.length }})</b-button>
						<b-button
							:variant="archive_filter === 'archived' ? 'secondary' : 'outline-secondary'"
							@click="archive_filter = 'archived'"
						>Archivés ({{ list_projects_archive.length }})</b-button>
					</b-button-group>
					<b-button
						size="sm"
						variant="outline-info"
						:disabled="archive_loading_treatments"
						@click="loadLastTreatments"
					>
						<b-spinner v-if="archive_loading_treatments" small class="mr-1"></b-spinner>
						<i v-else class="fas fa-history mr-1"></i>
						Dernier traitement
					</b-button>
					</div>

					<b-table
						:items="projects_filtered_for_archive"
						:fields="archive_table_fields"
						striped hover responsive small
						sort-icon-left
					>
<template #cell(last_treatment)="row">
						<span v-if="archive_last_treatments[row.item.uid] === undefined" class="text-muted">—</span>
						<span v-else-if="archive_last_treatments[row.item.uid] === null" class="text-muted"><em>aucun</em></span>
						<span v-else>{{ archive_last_treatments[row.item.uid] }}</span>
					</template>

					<template #cell(test_date)="row">
						<span v-if="row.item.test_date">{{ row.item.test_date }}</span>
						<span v-else class="text-muted"><em>jamais testé</em></span>
					</template>

					<template #cell(archive)="row">
							<b-badge :variant="row.item.archive ? 'secondary' : 'success'">
								{{ row.item.archive ? 'Archivé' : 'Actif' }}
							</b-badge>
						</template>

						<template #cell(actions)="row">
							<b-button
								v-if="!row.item.archive"
								size="sm"
								variant="outline-warning"
								@click="archiveProject(row.item)"
							>
								<i class="fas fa-archive"></i> Archiver
							</b-button>
							<b-button
								v-else
								size="sm"
								variant="outline-success"
								@click="unarchiveProject(row.item)"
							>
								<i class="fas fa-box-open"></i> Désarchiver
							</b-button>
						</template>
					</b-table>
				</b-tab>
				</b-tabs>
			</div>
			<div v-show="state == 'données'">
				<b-tabs v-model="tabIndex" content-class="mt-3">
					<b-tab
						title="Données initiales"
						active
						@click="
							() => {
								if (project_v2) toggleDataActionChoice(true);
							}
						">
						<div>
							<h3>Données initiales</h3>
							<div v-if="importedFile && project_v2">
								<b-button
									class="mb-2 float-right"
									variant="primary"
									@click="() => redirectToStep()">
									{{
										steps.length === 0
											? "Créez votre première étape"
											: "Créez une nouvelle étape"
									}}
									<i class="fas fa-share"></i>
								</b-button>
							</div>
							<b-form-select
								v-model="initial_method"
								:options="
									initial_method_options
								"></b-form-select>
							<br />
							<br />
							<div v-if="initial_method === 'Airtable'">
                  <InitDataAirtable
                      ref="start_tabulator">
                  </InitDataAirtable>
              </div>
							<div v-if="initial_method === 'Google sheets'">	
                  <InitDataGsheets
                      ref="start_tabulator">

                  </InitDataGsheets>
              </div>
							<div v-if="initial_method == 'fichier'">
								<div v-if="project_data.column_import">
									<b-button v-on:click="setColumnImport()"
										>Colonnes du projet</b-button
									>
									<br /><br />
								</div>
								<edit_tabulator
									:select_mode="true"
									:columns_type="tabulator_columns_type"
									:selectable="true"
									@update="importFile"
									ref="start_tabulator"></edit_tabulator>
							</div>
							<div v-if="initial_method == 'base de données'">
								<b-form-select
									v-model="table"
									:options="tables"
									v-on:input="updateTable" />
								<database
									v-show="table"
									:name="false"
									:edit="false"
									@update="importFile"
									ref="start_tabulator"></database>
								<br />
							</div>
							<div v-if="initial_method == 'base de données multibases'">
								<DatabaseRequestView
									:minimal="true"
									ref="start_tabulator" />
								<br />
							</div>
							<div v-if="initial_method == 'ensemble'">
								<ensemble
									:name="false"
									@update="importFile"
									ref="start_tabulator"></ensemble>
							</div>
							<div v-if="initial_method == 'fichiers'">
								<files-upload
									:name="false"
									:upload="false"
									@update="importFile"
									ref="start_tabulator"></files-upload>
							</div>
							<div v-if="initial_method == 'documents'">
								<documents
									:select="true"
									@update="importFile"
									ref="start_tabulator"
									:id_prefix="(init_data && init_data['documents'] && init_data['documents'].hasOwnProperty('id_prefix')) ? init_data['documents'].id_prefix : false"></documents>
							</div>
							<div v-if="initial_method == 'fichiers - url'">
								<files-upload 
									:name="false"
									:upload="true"
									@update="importFile"
									ref="start_tabulator" />
							</div>
						</div>
					</b-tab>

					<b-tab
						title="Fichier intermédiaire"
						:title-item-class="project_v2 ? 'hidden' : ''">
						<h3>Fichier intermédiaire</h3>
						<edit_tabulator
							:columns_type="tabulator_columns_type"
							:extern_file="false"
							ref="intermediate_tabulator"></edit_tabulator>
						<div v-if="missing_columns">
							<b-button
								variant="primary"
								v-b-toggle.missing_column
								class="m-1"
								>Colonnes manquantes</b-button
							>
							<b-collapse id="missing_column">
								<ul>
									<li
										v-for="column in missing_columns"
										:key="column">
										{{ column }}
									</li>
								</ul>
							</b-collapse>
						</div>
					</b-tab>

					<b-tab
						title="Fichier cible"
						:title-item-class="project_v2 ? 'hidden' : ''">
						<h3>Fichier cible</h3>
						<edit_tabulator
							:columns_type="tabulator_columns_type"
							@update="update_final_data"
							ref="final_tabulator"></edit_tabulator>
					</b-tab>

					<b-tab
						title="Colonnes"
						:title-item-class="project_v2 ? '' : ''">
						<h3>Colonnes</h3>
						<div ref="tabulator_columns" class="table-striped"></div>
						<b-button v-on:click="addLine()"
							><i class="fas fa-plus-circle"></i> ligne</b-button
						>
						<h3>Colonnes - types avancés</h3>

						<b-card v-for="(data, key) in tabulator_columns_type" :key="key">
							<p>Colonne : {{key}}</p>
							<p>Type
								<b-select v-model="data.type" :options='["", "image", "video", "html"]'></b-select>
							</p>
							<p>Blacklists and whitelist
								<b-checkbox v-model="data.black_white_lists" />
							</p>
							<b-button variant="link" @click="delete tabulator_columns_type[key]"><i class="fas fa-trash"></i></b-button>
						</b-card>
						<p>Nouvelle colonne
							<b-input v-model="tabulator_columns_type_new"></b-input>
						</p>
						<b-button
							@click="tabulator_columns_type[tabulator_columns_type_new] = {type: ''}; tabulator_columns_type_new = ''"
							variant="primary">
							<i class="fas fa-plus"></i>
						</b-button>


						<h3>Colonnes de résultats</h3>

						<array_editor ref="columns_result" :start_data="columns_result" @update="update_columns_result"
							:columns='[
								{name: "name", libelle: "Nom", type: "text"},
								{name: "type", libelle: "Type", type: "list", options: ["text", "textarea", "json"]},
								{name: "only_if_no_empty", libelle: "Afficher seulement si non vide", type: "checkbox"},
								{name: "picking", libelle: "Picking", type: "checkbox"},
							]'
						/>

					</b-tab>

					<b-tab
						title="Listes"
						@click="
							() => {
								if (project_v2) toggleDataActionChoice(false);
							}
						">
						<h3>Listes</h3>
						<b-tabs v-model="tabListIndex" content-class="mt-3">
							<b-tab
								:title="element.name"
								v-for="(element, idx) in listWords"
								:key="element.id">
								<listWords
									@update="updateList"
									:ref="element.id"
									:id="element.id"
									:db_mode="true"></listWords>
								<b-button
									size="sm"
									variant="danger"
									class="float-right"
									@click="removeListAt(idx)">
									Supprimer liste
								</b-button>
							</b-tab>
							<template #tabs-end>
								<b-nav-item
									role="presentation"
									@click.prevent="addList"
									href="#"
									><b>+</b></b-nav-item
								>
							</template>
						</b-tabs>
					</b-tab>					
					
					<b-tab v-show="config" title="Données initiales de traitement">
						<div :id="'jsoneditor-init-data-' + id"></div>

						<p>Configuration de la base de données</p>

						<database
							@update="initial_database"
							:name="false"
							:change_table="true"
							:edit="false"
							ref="initial_database"></database>
						<br />
					</b-tab>

					<b-tab v-show="config" title="Paramètres">
						<b-table :items="user_params" :fields="[
							{
								key: 'name',
								label: 'Nom',
							},
							{
								key: 'description',
								label: 'Description',
							}
						]
						"></b-table>	
						<p>
							Sauvegarde des paramètres - type					
							<b-input v-model="user_params_save" />
						</p>
						<p>
							Sauvegarde des paramètres - configuration par défaut					
							<b-input v-model="user_params_save_default" />
						</p>
						<b-checkbox v-model="user_params_test">Tester les paramètres</b-checkbox>
						<br />
						<h3>Paramètres</h3>
						<treatment_params :type_save="user_params_save" :files="steps.length > 0 ? steps[0].prev_files : []" :data="tabulator_import_data" @get_initial_files="get_initial_files" ref="treatment_params" @configuration="set_configuration"></treatment_params>
					</b-tab>

				</b-tabs>
			</div>
			<div v-show="state == 'etape'">
				<b-container style="margin: 0; padding: 0; max-width: none">
					<b-row
						ref="div_row"
						style="
							flex-wrap: nowrap !important;
							margin: 0;
							padding: 0;
							max-width: none;
						">
						<b-col
							ref="div_menu"
							md="auto"
							style="margin: 0; padding: 0; max-width: none">
							<h6 v-if="config || config_name">
								Scenario {{ name.substring(0, 30)
								}}{{ name.length > 30 ? "..." : "" }}
							</h6>

							<b-button
								:variant="
									state == 'configuration'
										? 'primary'
										: 'secondary'
								"
								@click="set_state('configuration')"
								><i class="fas fa-cogs"></i></b-button
							>&nbsp;
							<b-button
								:variant="
									state == 'données' ? 'primary' : 'secondary'
								"
								@click="set_state('données')"
								><i class="fas fa-file-alt"> data</i></b-button
							>&nbsp;
							<b-button
								:variant="
									state == 'etape' ? 'primary' : 'secondary'
								"
								@click="
									set_state('etape');
									if (project_v2) {
										toggleActionChoice(true);
									}
								"
								><i class="fas fa-list"> étapes</i></b-button
							>&nbsp;
							<b-button
								v-if="config"
								v-show="name && version"
								:variant="'secondary'"
								@click="save_db(false, false)"
								><i class="fas fa-save"></i
							></b-button>

							<br />

							<div v-if="project_v2 === false">
								Etapes
								<i
									class="fas fa-plus-square"
									@click="addStep()"></i>
							</div>
							<div
								v-if="project_v2"
								class="mt-1 rounded-md hover:outline hover: outline-1 hover:outline-gray-500 cursor-pointer"
								@click="() => toggleActionChoice(true)">
								Ajouter une étape
								<i class="fas fa-plus-square"></i>
							</div>
							<!-- * scrollable -->
							<div class="max-h-[75vh] overflow-y-scroll">
								<!-- * ne charge pas pendant qu'on modifie steps!
                        * cf stepsLoaded, mais attention à quand on rajoute une étape
                     -->
								<draggable
									group="step"
									:list="steps"
									class="list-group">
									<div
										v-for="(element, idx) in steps"
										:key="element.id">
										<span>
                                            <b-button
                                                :title="requiresTooltip[idx]"

												style="
													text-align: left !important;
												"
												variant="link"
												@click="
													view_step = element.id;
													view_idx = idx;
													if (project_v2) {
														toggleActionChoice(
															false
														);
													}
												"
												:style="'color:' + element.status + '; font-weight:' + (view_step == element.id ? 'bold' : 'normal')"
												>{{ idx + 1 }} -
												{{
													element.description != undefined
														? element.description.substring(0, element.description.indexOf(".")).substring(0,30) 
															|| element.description.substring(0,30) 
															|| element.data.label 
															|| "nouvelle étape" 
														: "nouvelle étape"
												}}
												{{ element.description ? element.description.length > 30 ? "..." : "" : "" }}
                                                {{ requiresTooltip[idx].length > 0 ? "*" : "" }}
												<span
													v-if="(element.errors && element.errors.length) > 0"
													style="color: red"
													>!</span>
											</b-button>
										</span>
										<div style="text-align: left !important;" v-if="element.data.action == 'group'">
											<!-- recursive composant menu, les étapes peuvent entrer et sortir du groupe -->
											&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fin du groupe
										</div>
									</div>
								</draggable>
							</div>
						</b-col>

						<div v-if="project_v2" v-show="actionChoiceOpened">
							<choix-action-step
								@create-step="
									(stepInfo) => addStepFromChoices(stepInfo)
								"></choix-action-step>
							<!-- todo à remplacer avec vuetabulator, on ne doit pas changer ces données elles ne sont reliées à rien -->
							<!-- <VueTabulator class="" v-show="tabulator_options.columns.length" ref="tabulator" :value="tabulator_data" :options="tabulator_options" :integration="{ updateStrategy: 'REPLACE' }"/> -->

							<edit_tabulator
								:style="'max-width: ' + (size - 100) + 'px'"
								:extern_file="false"
								:ref="'tabulator_action_choices'"
								:columns_type="tabulator_columns_type"
								></edit_tabulator>
						</div>

						<b-col ref="div_steps">
							<!-- * ne charge pas pendant qu'on modifie steps!
                    * cf stepsLoaded, mais attention à quand on rajoute une étape
                 -->
							<div
								v-for="(element, idx) in steps"
								:key="element.id">
								<div
									v-show="
										view_step == element.id &&
										!actionChoiceOpened
									">
									<i
										v-show="view_step == element.id"
										class="ml-2 cursor-pointer text-[--theme-text-color] fa fa-times close"
										@click="removeAt(idx)"></i>
									<step
										:action_id="element.id"
										v-on:set_action="set_action(element.id)"
										@make_list="make_list"
										@test="test"
										@test_by_line="test_by_line"
										@stop_test="f_stop_test"
										@change_status="change_status"
										@change_errors="change_errors"
										@change="change"
										@change_user_params="change_user_params"
										:prev_files="element.prev_files || []"
										:prev_urls="element.prev_urls"
										:projects="list_projects"
										:ref="element.id"
										:cible_data="final_tabulator_data"
										:load_data="element.load_data"
										:id="element.id"
										:prev_data="element.prev_data"
										:columns="tabulator_columns_data"
										:tables="tables"
										:size="size"
										:client="client"
										:list_words="listWords"
										:columns_type="tabulator_columns_type"
										:user_params_config="user_params_config"
										:user_params_test="user_params_test"
										:project_uid="project_uid"
										:step_position="idx"
										:lines_mode="lines_mode"
										:lines_nb="lines_nb"
										:show_user_params_editor="true"
										>
									</step>
									<!--  group step, recursif, composant avec les sous étapes eet les fonctions de test -->
								</div>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</div>
		</div>
	</div>
</template>

<script>
	import Tabulator from 'tabulator-tables/dist/js/tabulator.min.js';

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	const serialize = require("form-serialize");
	const clone = require("clone");

	const {Condition} = require("../utils/Condition");

	import { JSONEditor } from "@json-editor/json-editor";
	import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";
	import * as json2csv from "json2csv";
	import alasql from "alasql";
	import $ from "jquery";

	import store from "../store";
	import users from "../services/users.js";
	import utils from "../services/utils.js";
	import step from "../components/Step.vue";
	import stepv2 from "../components/Step_v2.vue";
	import choix_action_step from "../components/choix_action_step.vue";

	import tools from "../utils/Tools";
	import library from "../views/Library.vue";
	import element from "../services/element.js";
	import ensemble from "../views/Ensemble.vue";
	import workers from "../services/workers.js";
	import documents from "../views/Document.vue";
	import scenario from "../services/scenario.js";
	import projects from "../services/projects.js";
	import database from "../services/database.js";
	import databaseView from "../views/database.vue";
	import treatments from "../services/treatments.js";
	import listWords from "../components/listWords.vue";
	import file_upload from "../components/file_upload.vue";
    import array_editor from "../components/array_editor.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import draggable_tree from "../components/draggable_tree.vue";
	import treatment_params from "../components/treatment_params.vue";
	import DatabaseRequestView from "../views/DatabaseRequestView.vue";
    import InitDataGsheets from "../components/Project_v2/init_data_gsheets.vue";
    import InitDataAirtable from "../components/Project_v2/init_data_airtable.vue";

	export default {
		name: "project",
		components: {
			edit_tabulator,
			listWords,
			draggable,
			step,
			database: databaseView,
			ensemble,
			"files-upload": file_upload,
			"draggable-tree": draggable_tree,
			"step-v2": stepv2,
			"choix-action-step": choix_action_step,
			treatment_params,
			documents,
			DatabaseRequestView,
			array_editor,
			InitDataGsheets,
			InitDataAirtable
		},
		props: {
			state_prop: {
				default: "",
			},
			initial_method_prop: {
				default: "",
			},
			config: {
				default: true,
			},
			config_name: {
				default: false,
			},
			project_v2: {
				default: false,
			},
		},
		data() {
			return {
				user: {},
				ready: 0,

				client: {},
				ro: null,
				ro_test: null,
				size: 0,
				size_test: 0,

				state: this.project_v2 ? "données" : "configuration",
				state_test: "configuration",

				id: uniqueId(""),

				env_list: [""],
				sync_env: [],

				project: "",
				project_uid: this.$uuid.v4(),
				list_projects: [],
				projects_options: [],
				project_data: {},

				tests: {
					configuration: {
						end: false,
					},
					tests: [],
				},
				test_id: null,

				list_projects_archive: [],
				list_projects_archive_libelle: [],
				projects_archive_options: [],
				unarchive_uid: "",

				archive_filter: 'all',
				archive_last_treatments: {},
				archive_loading_treatments: false,

				first_test_done: false,

				initial_method_options: [
					{ value: "fichier", text: "fichier csv"},
					"base de données",
					"base de données multibases",
					"ensemble",
					"fichiers",
					"documents",
                    "Google sheets",
					"Airtable",
					"fichiers - url"
				],
				initial_method: "fichier",
				tables: [],
				table: "",

				tabulator_import_data: null,
				tabulator_columns_type: {},
				tabulator_columns_type_new: "",

				tabulator_columns: null, // Instance Tabulator
				tabulator_columns_data: [{ colonne: "", type: "texte" }],
				tabulator_columns_options: {
					paginationSize: 10,
					pagination: "local",
					columns: [
						{
							title: "colonne",
							field: "colonne",
							editor: "input",
						},
						{
							title: "type",
							field: "type",
						editor: "list",
						editorParams: {
							values: ["texte", "nombre"],
						},
					},
				],
			},

			steps: [],
			results: false,

		missing_columns: null,
		final_tabulator_data: [],
		tabulator_data: null,
		collapse: true,

		tabIndex: 0,
		redraw: true,

		listWords: [],
		tabListIndex: 0,
		collapse_list: true,

		name: "",
		version: "",
		_version: "",
		description: "",
		description_project: "",
		short_description_project: "",
		comment_project: "",
		version_test: false,
		version_prod: true,
		version_env: false,

		list_name: [],
		list_version: [],
		next_version: 1,
		save_exist: false,
		prod_version: "",

		load_name: "",
		load_version: "",

		new_name: "",

		view_step: "",
		view_idx: 0,

		config_index: 0,

		tags: [],
		treatment_actions: [],
		init_data: {
		},

		editor: null,
		editor_actions: null,
		editor_init: null,

		stepsLoaded: false,

		// * project_v2
		actionChoiceOpened: false,
		dataActionChoiceOpened: true,
		importedFile: false,

		inDropdownTraitements: true,
		inDropdownPostTreatments: false,
				generating_descriptions: false,
				description_progress: 0,
				description_current: 0,

				user_params: [],
				user_params_test: false,
				user_params_save: "",
				user_params_save_default: "",
				user_params_config: "",

				active_watch: true,
				render_files: true,
				browser: true,
				sub_treatment: false,
				next_treatments: [],

				columns_result: [],

				stop_test: false,

				lines: false,
				lines_mode: false,
				steps_lines: [],
				lines_nb: 1,
				generating_project_description: false,
				generate_only_empty_descriptions: true,
				custom_prompt_project: "",
				show_custom_prompt_project: false
			};
		},
		watch: {
			tabulator_columns_data: {
				handler(newData) {
					if (this.tabulator_columns && newData) {
						this.tabulator_columns.replaceData(newData);
					}
				},
				deep: true
			},
			'$route.params.id': {
				async handler () {
					//console.log(this.$route.params.id)
					if (this.uid != this.$route.params.id)
					{
						var sc = await scenario.getby_id(this.$route.params.id);
						if (sc && sc.length > 0)
						{
							this.active_watch = false;
							this.load_name = sc[0].libelle;
							this.load_version = sc[0].version;
							await this.load_db();
							this.active_watch = true;
						}
					}
				}
			},
			inDropdownTraitements: {
				handler() {
					this.project_data.inDropdownTraitements =
						this.inDropdownTraitements;
				},
			},
			inDropdownPostTreatments: {
				handler() {
					this.project_data.inDropdownPostTreatments =
						this.inDropdownPostTreatments;
				},
			},
			tabIndex: {
				handler() {
					if (this.redraw && this.tabIndex) {
						var self = this;
						setTimeout(function () {
							self.redraw = false;
							self.$refs.final_tabulator.redraw();

							// self.$refs.tabulator_columns.getInstance().redraw(true);
						}, 100);
					}
				},
			},
			load_name: {
				async handler(newVal, oldVal) {
					// Vérifier que load_name existe et n'est pas vide
					if (!newVal || newVal === '') {
						console.log("load_name est vide ou undefined, annulation du watch");
						return;
					}

					var scenarios = await scenario.getby_libelle(
						newVal
					);

					console.log("this.load_name")
					console.log(newVal)

					this.list_version = [];
					for (var i = 0; i < scenarios.length; i++) {
						if (i == 0 && this.active_watch) 
							this.load_version = scenarios[i].version;
						this.list_version.push({"description": scenarios[i].description, "value": scenarios[i].version, "text" : scenarios[i].dateheure + " - v " + scenarios[i].version});
					}

					if (this.active_watch)
						await this.load_db();
				},
			},
		},
        computed: {
				_canGenerateIa() {
					const rules = store.state.user ? store.state.user.rules : undefined;
					if (rules === null) return true;
					return !!(rules && rules.generate_ia);
				},
					archive_table_fields() {
					const fields = [
						{ key: 'libelle', label: 'Nom', sortable: true },
					];
					if (Object.keys(this.archive_last_treatments).length > 0)
						fields.push({ key: 'last_treatment', label: 'Dernier traitement', sortable: true });
					fields.push({ key: 'test_date', label: 'Dernier test éditeur', sortable: true });
					fields.push({ key: 'archive', label: 'Statut', sortable: true });
					fields.push({ key: 'actions', label: 'Actions' });
					return fields;
				},
				projects_filtered_for_archive() {
					const all = [
						...this.list_projects.map(p => ({ ...p, archive: false })),
						...this.list_projects_archive.map(p => ({ ...p, archive: true })),
					];
					all.forEach(p => {
						const v = this.archive_last_treatments[p.uid];
						p.last_treatment = v !== undefined ? v : null;
						const fd = p.details && p.details.test_date;
						p.test_date = fd ? fd.replace('T', ' ').substring(0, 16) : null;
					});
					all.sort((a, b) => (a.libelle || '').localeCompare(b.libelle || '', 'fr', { sensitivity: 'base' }));
					if (this.archive_filter === 'active')
						return all.filter(p => !p.archive);
					if (this.archive_filter === 'archived')
						return all.filter(p => p.archive);
					return all;
				},
            // * calculated *once* every time steps change
            requiresTooltip() {
                var needReload = false;

                var self = this;

                var requireTooltipArr = this.steps.map((step, idx) => {
                    var stepTooltip = "";

                    stepTooltip += (step.source_data && step.source_data.length > 0) ? `Source data: ${step.source_data}\n` : "";

                    // convert array of strings to strnig

                    stepTooltip += (self.stepTags[idx].length > 0) ? `Tags: ${self.stepTags[idx]}\n` : "";
                    stepTooltip += (step.data && step.data.parameters !== undefined && (step.data.parameters.cut_start)) ? `Cut start: ${step.data.parameters.cut_start}` : "";	
					stepTooltip += (step.data && step.data.parameters !== undefined && (step.data.parameters.cut_end)) ? `Cut end: ${step.data.parameters.cut_end}` : "";	
					stepTooltip += (step.data && step.data.notifications) ? `Notifications saas` : "";	

                    needReload |= stepTooltip;

                    return stepTooltip;
                });

                if (needReload)
                    this.$forceUpdate();

                return requireTooltipArr;
            },
            // * calculated *once* every time steps change
            stepTags() {
                var self = this;
                return this.steps.map((step, idx) => {
                    var tags = "";

					if (self.tags)
					{
						for (let i = 0; i < self.tags.length; i++) {
							if (idx >= self.tags[i].start - 1 && idx <= self.tags[i].end - 1) {
								// * s'il yen a plus d'un, et qu'on est pas à la fin, on ajoute une virgule
								tags += self.tags[i].name + ((self.tags.length > 1 && i !== self.tags.length - 1) ?  ", " : "");
							}
						}
					}
                    return tags;
                });
            }
        },
		methods: {
			async generate_all_descriptions() {
				if (this.steps.length === 0) {
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Erreur',
						text: 'Aucune étape à traiter'
					});
					return;
				}

				this.generating_descriptions = true;
				this.description_progress = 0;
				this.description_current = 0;

				let generated_count = 0;
				let skipped_count = 0;

				for (let i = 0; i < this.steps.length; i++) {
					this.description_current = i + 1;
					
					try {
						const stepRef = this.$refs[this.steps[i].id];
						if (stepRef && stepRef[0] && typeof stepRef[0].generate_description === 'function') {
							// Vérifier si on doit générer uniquement pour les étapes vides
							if (this.generate_only_empty_descriptions) {
								const long_description = stepRef[0].get_long_description();
								if (long_description && long_description.trim() !== '') {
									// L'étape a déjà une description, on la saute
									skipped_count++;
									this.description_progress = i + 1;
									continue;
								}
							}
							
							await stepRef[0].generate_description();
							generated_count++;
							
							// Petite pause pour éviter de surcharger l'API
							await new Promise(resolve => setTimeout(resolve, 500));
						}
					} catch (error) {
						console.error(`Erreur lors de la génération de la description pour l'étape ${i + 1}:`, error);
					}

					this.description_progress = i + 1;
				}

				this.generating_descriptions = false;
				
				let message = `${generated_count} description(s) générée(s) avec succès`;
				if (skipped_count > 0) {
					message += ` (${skipped_count} étape(s) ignorée(s) car déjà remplie(s))`;
				}
				
				this.$notify({
					group: 'info',
					type: 'success',
					title: 'Terminé',
					text: message
				});
			},
			get_step_info(stepId) {
				const stepRef = this.$refs[stepId];
				if (stepRef && stepRef[0]) {
					return {
						comment: stepRef[0].get_comment(),
						long_description: stepRef[0].get_long_description(),
						action_label: stepRef[0].get_action_label(),
						description: stepRef[0].get_description()
					};
				}
				return {
					comment: "",
					long_description: "",
					action_label: "",
					description: ""
				};
			},
			async toggle_custom_prompt_project() {
				if (this.show_custom_prompt_project) {
					this.show_custom_prompt_project = false;
					return;
				}
				if (!this.custom_prompt_project)
					this.custom_prompt_project = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description générale de ce que fait le scénario complet (objectif global et résultat attendu), pas une explication détaillée de chaque étape.

Contraintes:
- Interdit: lister toutes les étapes une par une, expliquer le code ligne par ligne.
- Autorisé: décrire le flux global, les transformations principales, l'objectif métier du scénario.`;
				this.show_custom_prompt_project = true;
			},
			reset_custom_prompt_project() {
				this.custom_prompt_project = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description générale de ce que fait le scénario complet (objectif global et résultat attendu), pas une explication détaillée de chaque étape.

Contraintes:
- Interdit: lister toutes les étapes une par une, expliquer le code ligne par ligne.
- Autorisé: décrire le flux global, les transformations principales, l'objectif métier du scénario.`;
			},
			async build_project_description_prompt() {
				var request = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description générale de ce que fait le scénario complet (objectif global et résultat attendu), pas une explication détaillée de chaque étape.

Contraintes:
- Interdit: lister toutes les étapes une par une, expliquer le code ligne par ligne.
- Autorisé: décrire le flux global, les transformations principales, l'objectif métier du scénario.

`;
				if (this.custom_prompt_project && this.custom_prompt_project.trim())
					request = this.custom_prompt_project.trim() + "\n\n";

				request += "Nom du projet : " + this.name + "\n\n";

				if (this.comment_project) {
					request += "Commentaire du projet : " + this.comment_project + "\n\n";
				}

				if (this.steps.length > 0) {
					request += "Liste des étapes du scénario :\n";

					for (let i = 0; i < this.steps.length; i++) {
						const step = this.steps[i];
						const stepRef = this.$refs[step.id];

						if (stepRef && stepRef[0]) {
							const stepData = await stepRef[0].save();

							request += `\nÉtape ${i + 1}: ${stepData.description || stepData.actionLabel || stepData.action}\n`;

							if (stepData.long_description && stepData.comment) {
								request += `Description: ${stepData.long_description}\n`;
								request += `Commentaire: ${stepData.comment}\n`;
							} else if (stepData.long_description) {
								request += `Description: ${stepData.long_description}\n`;
							} else if (stepData.comment) {
								request += `Commentaire: ${stepData.comment}\n`;
							} else {
								const action = stepData.action;
								const ActionComment = stepRef[0].ActionComment;

								if (ActionComment && ActionComment[action]) {
									request += `Type d'action: ${ActionComment[action]}\n`;
								}

								if (typeof stepRef[0].getRules === 'function') {
									const rules = stepRef[0].getRules();
									if (rules) request += `Conditions: ${rules}\n`;
								}

								if (stepData.data && stepData.data.parameters) {
									request += `Paramètres: ${JSON.stringify(stepData.data.parameters)}\n`;
								}
							}
						}
					}
				}

				return request;
			},
			async generate_project_description() {
				if (!this.name) {
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Erreur',
						text: 'Le nom du projet est requis'
					});
					return;
				}

				this.generating_project_description = true;

				try {
					const request = await this.build_project_description_prompt();

					var formData = new FormData();
					formData.append("action", "saas_back-openai");
					formData.append("parameters", JSON.stringify({
						"config": "documentation scenario",
						"template": false,
						"content": "request",
						"column_result": "result",
						"column_error": "error",
					}));

					var data = [{request: request }];

					var str_csv = json2csv.parse(data, {
						fields: Object.keys(data[0]),
						fieldNames: Object.keys(data[0]),
					});

					var files = [
						new File([str_csv], "data.csv", {
							type: "text/csv",
						}),
					];

					formData.append(files[0].name, files[0], "data.csv");

					var result = await workers.test(formData);
					var csv_data = await treatments.getFileAlyx(
						result.data.files[0].url,
						false,
						false
					);
					var parsed_data = this.$papa.parse(csv_data, {
						header: true,
					});
					parsed_data = parsed_data.data;

					this.description_project = parsed_data[0].result;

					this.$notify({
						group: 'info',
						type: 'success',
						title: 'Succès',
						text: 'Description du projet générée avec succès'
					});

				} catch (error) {
					console.error('Erreur lors de la génération de la description du projet:', error);
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Erreur',
						text: 'Erreur lors de la génération de la description'
					});
				} finally {
					this.generating_project_description = false;
				}
			},
			async set_configuration(config)
			{
				this.user_params_config = config;
			},
			async update_columns_result(data)
			{
				this.columns_result = data;
			},
			async zip()
			{
				scenario.zip()
			},
			async get_initial_files(idx)
			{
				var files = await this.$refs.start_tabulator.get_data_files(false);
				this.$refs.treatment_params.set_initial_files(idx, files);
			},
			updateStepV2: function (stepInfo, idx) {
				// let newStep = {description: stepInfo.title, id: this.steps, prev_files, prev_data, data: { action : "" }, status:"black"};

				this.steps[idx].action_choices = stepInfo.schemas;
				this.steps[idx].actionGroupDesignation = stepInfo.title;
				// this.steps[idx].description = "";
			},
			addStepFromChoices: async function (stepInfo) {
				// step info contient le nom des actions possibles stepInfo.schemas

				this.actionChoiceOpened = false;

				if (this.steps.length === 0) {
					var prev_data = this.$refs.start_tabulator.get_data();
					var prev_files =
						await this.$refs.start_tabulator.get_data_files(false);
				} else if (this.view_step === "") {
					var prev_data =
						this.$refs[
							this.steps[this.steps.length - 1].id
						][0].get_data();
					var prev_files = await this.$refs[
						this.steps[this.steps.length - 1].id
					][0].get_data_files(false);
				} else {
					//console.log(this.view_step)
					var prev_data = this.$refs[this.view_step][0].get_data();
					var prev_files = await this.$refs[
						this.view_step
					][0].get_data_files(false);
				}
				let id = uniqueId("");

				let newStep = {
					description: stepInfo.title,
					id: id,
					prev_files,
					prev_data,
					data: { action: "" },
					status: "black",
				};

				newStep.action_choices = stepInfo.schemas;
				newStep.actionGroupDesignation = stepInfo.title;

				if (this.view_step === "") {
					this.steps.push(newStep);
					this.view_idx = this.steps.length - 1;
				} else {
					this.steps.splice(this.view_idx + 1, 0, newStep);
					this.view_idx++;
				}

				// todo changer l'onglet actif à steps
				this.state = "etape";

				this.view_step = id;
			},
			redirectToStep() {
				// state = steps
				this.state = "etape";
				this.toggleActionChoice(true);
			},
			toggleDataActionChoice(isOpen) {
				this.dataActionChoiceOpened = isOpen;
			},
			toggleActionChoice(isOpen) {
				this.actionChoiceOpened = isOpen;

				// * alimenter un tabulator avec: start data ou data de l'étape précédente
				var prev_data = null;
				// * comment on récupère les données précédentes avec les URL du coup ?

				if (this.steps.length === 0 || this.view_step === "") {
					// console.log("Getting initial data");
					prev_data = this.$refs.start_tabulator.get_data();
				} else {
					// console.log("Getting data from step because view_step is not empty: ", this.view_step);
					// console.log("Starting from: ", parseInt(this.view_idx), " and going down");

					// revenir en arrière jusqu'à trouver une étape avec de la data
					for (let i = parseInt(this.view_idx); i >= 0; i--) {
						let stepID = this.steps[i].id;
                        if (this.$refs[stepID]) {
                            prev_data = this.$refs[stepID][0].get_data();
                            // console.log("Got data from step: ", stepID, " with data: ", prev_data);
                            if (prev_data !== null && prev_data.length > 0) break;
                        }
					}
					if (prev_data === null || prev_data.length === 0) {
						// console.log("No step data found, reverting to initial data");
						prev_data = this.$refs.start_tabulator.get_data();
					}
				}
				if (this.$refs["tabulator_action_choices"]) {
					//console.log("Prev data: ", prev_data);
					this.$refs["tabulator_action_choices"].load(prev_data);
				}
			},
			async save(save_file = true, next_version = true) {
				if (next_version) this.version = this.next_version;

				if (save_file) document.body.style.cursor = "wait";

				//console.log(this.name)

				var tests = clone(this.tests);
				for (var i = 0; i < tests.tests.length; i++) {
					var test = tests.tests[i];
					test.color = "";

					for (var j = 0; j < test.steps.length; j++) {
						if (test.steps[j].test_data)
							delete test.steps[j].test_data;
						if (test.steps[j].diff) delete test.steps[j].diff;
					}
				}

				this.lines_nb = parseInt(this.lines_nb);
				for (var i = 0; i < this.steps_lines.length; i++)
				{
					this.steps_lines[i].step_start = parseInt(this.steps_lines[i].step_start);
					this.steps_lines[i].step_end = parseInt(this.steps_lines[i].step_end);
				}

				if (this.lines_mode === true)
					this.lines = true;
				else
					this.lines = false;

				var save = {
					tests: tests,
					project: this.project,
					project_uid: this.project_uid,
					tabulator_import_data:
						this.$refs.start_tabulator.save() || [],
					tabulator_columns_data: this.tabulator_columns_data,
					tabulator_columns_type: this.tabulator_columns_type,
					tabulator_data: this.tabulator_data,
					initial_database: await this.$refs.initial_database.save(),
					start_tabulator: this.$refs.start_tabulator.save() || [],
					final_tabulator: this.$refs.final_tabulator.save() || [],
					steps: [],
					collapse: this.collapse,
					listWords: this.listWords,
					initial_method: this.initial_method,
					table: this.table,
					name: this.name,
					version: this.version,
					description: this.description,
					description_project: this.description_project,
					short_description_project: this.short_description_project,
					comment_project: this.comment_project,
					version_test: this.version_test,
					tags: this.tags,
					treatment_actions: this.treatment_actions,
					init_data: this.init_data,
					user_params: this.user_params,
					inDropdownTraitements: this.inDropdownTraitements,
					inDropdownPostTreatments: this.inDropdownPostTreatments,
					render_files: this.render_files,
					browser: this.browser,
					sub_treatment: this.sub_treatment,
					next_treatments: this.next_treatments,
					columns_result: this.columns_result,
					user_params_save: this.user_params_save,
					user_params_save_default: this.user_params_save_default,
					lines: this.lines,
					lines_mode: this.lines_mode,
					lines_nb: this.lines_nb
				};

				for (var i = 0; i < this.listWords.length; i++) {
					if (this.listWords[i].parameters.db)
						await element.save(
							this.listWords[i].name,
							this.listWords[i].parameters.version,
							this.listWords[i],
							"list"
						);
				}


				if (this.lines_mode === "steps")
				{
					this.steps_lines = [];
				}
				else
					this.steps_lines = false;

				var step_line = null;


				for (var i = 0; i < this.steps.length; i++) 
				{
					var step = this.$refs[this.steps[i].id][0].save();

					if (this.steps_lines && step.lines)
					{
						console.log(" --- ")
						console.log(step_line)
						console.log(i)
						if (step_line == null)
						{
							console.log("null")
							step_line = {
								step_start: i + 1,
								step_end : i + 1
							}
						}
						else
						{
							if (step_line.step_end == i)
							{
								console.log("add")
								step_line.step_end = i + 1;
							}
							else
							{
								console.log("new")
								this.steps_lines.push(step_line);
								step_line = {
									step_start: i + 1,
									step_end : i + 1
								}
							}
						}
					}

					if (
						save_file &&
						step.action == "base de données" &&
						step.data.parameters.token
					)
						delete step.data.parameters.token;
					step.test = this.steps[i].test;

					// * undefined restera undefined
					step.action_choices = this.steps[i].action_choices;
					step.description = this.steps[i].description;
					step.actionGroupDesignation =
						this.steps[i].actionGroupDesignation;
					// console.log("Saving step: " + JSON.stringify(step));
					save.steps.push(step);
				}

				if (this.steps_lines && step_line)
					this.steps_lines.push(step_line);

				save.step_lines = this.steps_lines;

				if (save_file) {
					document.body.style.cursor = "default";
					this.config_index = 1;
					utils.saveToFile(
						JSON.stringify(save),
						this.name ? this.name + ".json" : "scenario.json"
					);
				} else return save;
			},
			async load(data, file = false) {
				//console.log("load start: ", new Date());
				while (this.ready < 2) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}

				if (data.studio_v2) {
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Scénario non compatible',
						text: 'Ce scénario a été ouvert avec le studio v2 et ne peut plus être chargé dans le studio v1.'
					});
					document.body.style.cursor = 'default';
					return;
				}

				var self = this;

				self.missing_columns = null;
				self.tabIndex = 0;
				self.redraw = true;
				self.tabulator_import_data = data.tabulator_import_data;
				self.tabulator_columns_data = [];

				self.inDropdownTraitements =
					data.inDropdownTraitements === undefined
						? true
						: data.inDropdownTraitements;

				self.inDropdownPostTreatments =
					data.inDropdownPostTreatments === undefined
						? false
						: data.inDropdownPostTreatments;

				var columns = [];
				if (data.tabulator_columns_data) {
					for (
						var i = 0;
						i < data.tabulator_columns_data.length;
						i++
					) {
						if (
							!columns.includes(
								data.tabulator_columns_data[i].colonne
							)
						)
							self.tabulator_columns_data.push(
								data.tabulator_columns_data[i]
							);
						columns.push(data.tabulator_columns_data[i].colonne);
					}
				}
				self.render_files = data.hasOwnProperty("render_files") ? data.render_files : true;
				self.browser = data.hasOwnProperty("browser") ? data.browser : false;
				self.sub_treatment = data.hasOwnProperty("sub_treatment") ? data.sub_treatment : false;
				self.next_treatments = data.hasOwnProperty("next_treatments") ? data.next_treatments : [];
				self.project_uid = file ? this.$uuid.v4() : (data.project_uid || this.$uuid.v4());
				self.tabulator_data = data.tabulator_data;
				self.collapse = false;
				self.collapse_list = false;
				self.listWords = data.listWords || [];
				self.tabulator_columns_type = data.tabulator_columns_type || {};
				self.initial_method = data.initial_method || "fichier";
				self.table = data.table || "";
				self.name = data.name || "";
				self.version = data.version || "";
				self.description = data.description || "";
				self.description_project = data.description_project || "";
				self.short_description_project = data.short_description_project || "";
				self.comment_project = data.comment_project;
				self.version_test = data.version_test || false;
				self.tags = data.tags;
				self.treatment_actions = data.treatment_actions || [];
				self.init_data = data.init_data || {};
				self.user_params = data.user_params || [];
				self.columns_result = data.columns_result || [];
				self.user_params_save = data.user_params_save || "";
				self.user_params_save_default = data.user_params_save_default || "";
				self.lines = data.lines || false;
				self.lines_mode = data.lines_mode || false;
				self.steps_lines = data.steps_lines || [];
				self.lines_nb = data.lines_nb || 1;

				this.$refs.columns_result.load(self.columns_result);
				if (data.tests) 
					self.tests = data.tests;
				else {
					self.tests = {
						configuration: {
							end: false,
						},
						tests: [],
					};
				}

				//console.log("load")
				var listWords = clone(data.listWords); // * pas besoin de jquery sinon [...data.listWords]
				//console.log(JSON.stringify(data.listWords))

				if (data.project && !self.project) {
					self.project = data.project;
					await self.setProject();
				}

				self.steps = [];

				//console.log("Steps length: ", data.steps.length);
				for (var i = 0; i < data.steps.length; i++) {
					var id = uniqueId("");
					var step = {
						test: data.steps[i].test || false,
						description: data.steps[i].description,
						data: {},
						status: "black",
						id,
						prev_files: [],
						load_data: data.steps[i],
						source_data: data.steps[i].source_data || "",
						file_result: data.steps[i].file_result || false,
				};
				self.steps.push(step);
				}

				// * empeche les élements step de se régénérer tant qu'on n'a pas fini de charger les steps
				self.stepsLoaded = true;

				// console.log("Setting next tick: ", new Date());

				self.$nextTick(async function () {
					// * ces fonctions ne sont pas asynchrones, ça sert à rien d'await
					await self.$refs.final_tabulator.load(data.final_tabulator);
					await self.$refs.start_tabulator.load(
						data.start_tabulator,
						self.table
					);

					for (var i = 0; i < listWords.length; i++) {
						if (self.$refs[listWords[i].id]) {
							await self.$refs[listWords[i].id][0].setData(
								listWords[i].name,
								listWords[i].list,
								listWords[i].parameters
							);
						}
					}

					document.body.style.cursor = "default";
					//console.log("Reset cursor");
					self.config_index = 1;

					self.editor_actions.setValue(self.treatment_actions);
					var fichier_init_len = self.init_data && self.init_data.fichier && self.init_data.fichier.init ? self.init_data.fichier.init.length : 0;
					console.log("[v1 load] editor_init.setValue - init_data.fichier.init.length =", fichier_init_len);
					self.editor_init.setValue(self.init_data);

					if (data.tests) {
						//console.log("test")
						//console.log(data.tests)
						for (var i = 0; i < data.tests.tests.length; i++) {
							var test = data.tests.tests[i];

							//console.log(test)

							this.$refs["tabulator" + i][0].load(
								test.start_data
							);

							for (var j = 0; j < test.steps.length; j++) {
								self.$refs[
									"tabulator" +
										i +
										test.steps[j].step.data["uid"]
								][0].load(test.steps[j].data);
							}
						}
					}

					if (self.tags) self.editor.setValue(self.tags);

					if (data.initial_database)
						await self.$refs.initial_database.load(data.initial_database)
				});
			},
			async parse_file(file) {
				const reader = new FileReader();
				reader.readAsText(file);
				const result = await new Promise((resolve, reject) => {
					reader.onload = function (event) {
						resolve(reader.result);
					};
				});
				return result;
			},
			async load_file(event) {
				document.body.style.cursor = "wait";
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);

						self.load(data, true);
					};
				})(file);

				reader.readAsText(file);
			},
			async save_db(test_scenario = true, next_version = true) {
				//console.log("save scenario db");
				document.body.style.cursor = "wait";

				this.first_test_done = false;

				if (next_version) this.version = this.next_version;

				if (test_scenario) {
					var result = await scenario.load(this.name, this.version);
					if (result.msg != "no scenario") {
						this.save_exist = true;
						document.body.style.cursor = "default";
						return;
					}
				}
				this.save_exist = false;

				var json_data = await this.save(false, next_version);
				var result = await scenario.save(
					this.name,
					this.version,
					this.description,
					this.description_project,
					json_data,
					!this.version_prod,
					this.version_env,
					this.sync_env,
					this.user_params,
					this.tabulator_columns_type,
					{
						tabulator_columns_type: this.tabulator_columns_type,
						columns_result: this.columns_result, 
						user_params_save: this.user_params_save, 
						user_params_save_default: this.user_params_save_default,
						sub_treatment: this.sub_treatment,
						next_treatments: this.next_treatments,
						lines: this.lines,
						steps_lines: this.steps_lines,
						lines_nb: this.lines_nb
					}
				);
				console.log(result)
				document.body.style.cursor = "default";
				if (result.status != 200 || result.errors)
				{
					this.$notify({
						group: "info",
						title: "Erreur de sauvegarde",
						text:
							"Erreur lots de la sauvegarde du scénario " +
							this.name +
							"  (version " +
							this.version +
							") : " + result.errors,
						type: "error",
						duration: -1
					});
				}
				else
				{
					this.$notify({
						group: "info",
						title: "Sauvegarde effectuée",
						text:
							"Le scénario " +
							this.name +
							"  (version " +
							this.version +
							") à été sauvegardé.",
						type: "success",
					});
				}
				this.config_index = 1;

			var scenarios = await scenario.getby_production();

			this.list_name = [];
			for (var i = 0; i < scenarios.length; i++) {
				if (
					!this.list_projects_archive_libelle.includes(
						scenarios[i].libelle
					)
				)
					this.list_name.push({value: scenarios[i].libelle, text: scenarios[i].libelle});
			}				var scenarios = await scenario.getby_libelle(this.name);

				this.list_version = [];
				for (var i = 0; i < scenarios.length; i++) {
					if (i == 0) 
						this.version = scenarios[i].version;
					this.list_version.push({"value": scenarios[i].version, "text" : scenarios[i].dateheure + " - v " + scenarios[i].version});
				}
				this.next_version = scenarios.length + 1;

				if (this.user.env && this.version_env) this.prod_version = "";
				if (!this.user.env && this.version_prod) this.prod_version = "";

				// Refresh project_data in case the save created a new project (e.g. name changed)
				if (result.project_uid)
					await this.setProject(result.project_uid);

				this.sync_env = [];
			},
			async load_db(load_name, load_version) {

				//console.log("load_db " + load_name + " - " + load_version)

				this.first_test_done = false;

				if (load_name) this.load_name = load_name;
				if (load_version) this.load_version = load_version;

				document.body.style.cursor = "wait";
				var result = await scenario.load(
					this.load_name,
					this.load_version
				);

				//console.log("Time before this.load", new Date());

				this.load(result).then(() => {
					//console.log("Time after this load", new Date());
				});

				this.next_version = this.list_version.length + 1;
				this.uid = result.uid;

				if (this.active_watch && this.$router.currentRoute.path.startsWith("/scenario_v1"))
					this.$router.push({ path: '/scenario_v1/'+this.uid });

				this.version_env = false;
				this.prod_version = "";
				//console.log(result)
				if (result.project_uid) 
					await this.setProject(result.project_uid);
				else
					return;
				if (this.user.env) {
					if (
						this.uid &&
						this.project_data.details &&
						this.project_data.details.env &&
						this.project_data.details.env[this.user.env] &&
						this.project_data.details.env[this.user.env].scenario ==
							this.uid
					)
						this.version_env = true;
					else {
						this.version_env = false;
						if (this.project_data.details && this.project_data.details.env && this.project_data.details.env[this.user.env])
						{
							await this.actual_prod_version(
								this.project_data.details.env[this.user.env].scenario
							);
						}
						else
							await this.actual_prod_version(
								this.project_data.details.scenario
							);
					}
				} else {
					if (
						!this.user.env &&
						this.project_data.details.scenario == this.uid
					)
						this.version_prod = true;
					else {
						this.version_prod = false;
						await this.actual_prod_version(
							this.project_data.details.scenario
						);
					}
				}

				//console.log("end load scenario")
			},
			async actual_prod_version(uid) {
				var s = await scenario.getby_id(uid);
				if (s && s.length > 0)
				{
					if (s[0].version == this.version)
						this.prod_version = false;
					else
						this.prod_version = s[0].version;
				}
			},
			async archiveProject(item) {
				try {
					await scenario.archive(item.libelle);
					const idx = this.list_projects.findIndex(p => p.uid === item.uid);
					if (idx !== -1) {
						const [removed] = this.list_projects.splice(idx, 1);
						removed.archive = true;
						this.list_projects_archive.push(removed);
					}
					this.$notify({ group: 'info', title: item.libelle + ' archivé', type: 'success' });
				} catch(e) {
					this.$notify({ group: 'info', title: "Erreur lors de l'archivage", type: 'error' });
				}
			},
			async unarchiveProject(item) {
				try {
					await scenario.unarchive(item.uid);
					const idx = this.list_projects_archive.findIndex(p => p.uid === item.uid);
					if (idx !== -1) {
						const [removed] = this.list_projects_archive.splice(idx, 1);
						removed.archive = false;
						this.list_projects.push(removed);
					}
					this.$notify({ group: 'info', title: item.libelle + ' désarchivé', type: 'success' });
				} catch(e) {
					this.$notify({ group: 'info', title: "Erreur lors du désarchivage", type: 'error' });
				}
			},
			async loadLastTreatments() {
				this.archive_loading_treatments = true;
				const allProjects = [
					...this.list_projects,
					...this.list_projects_archive,
				];
				for (const project of allProjects) {
					try {
						const t = await treatments.getAllId(project.uid, 0, 1);
						this.$set(this.archive_last_treatments, project.uid,
							t && t.dateheure_debut ? t.dateheure_debut.replace('T', ' ').substring(0, 16) : null
						);
					} catch(e) {
						this.$set(this.archive_last_treatments, project.uid, null);
					}
				}
				this.archive_loading_treatments = false;
			},
			// Conservé pour compatibilité (utilisé ailleurs dans le composant)
			async archive() {
				if (this.name) await this.archiveProject({ libelle: this.name, uid: null });
			},
			async unarchive() {
				if (this.unarchive_uid) await this.unarchiveProject({ uid: this.unarchive_uid, libelle: this.unarchive_uid });
			},
			async rename() {
				if (this.list_name.includes(this.new_name)) {
					this.$notify({
						group: "info",
						title: this.new_name + "  existe déjà",
						type: "error",
					});

					return;
				}

				await scenario.rename(this.name, this.new_name);
				this.name = this.new_name;
				this.save_db(false, false);
			},
			update_name(name) {
				this.name = name;
			},
			set_version(version) {
				this.version = version;
			},
			update_version() {
				if (this.project_data.details)
				{
					if (this.user.env) {
						if (
							this.project_data.details &&
							this.project_data.details.env &&
							this.project_data.details.env[this.user.env]
						)
							this.actual_prod_version(this.project_data.details.env[this.user.env].scenario);
						else
							this.actual_prod_version(this.project_data.details.scenario);
					} else {
						this.actual_prod_version(this.project_data.details.scenario);
					}
				}

				this.next_version = this.version;
			},

			async set_test(idx) {
				var self = this;

				var test = this.tests.tests[idx];

				var data = this.$refs.start_tabulator.get_data();
				test.start_data = clone(data);
				this.$refs["tabulator" + idx][0].load(test.start_data);

				test.steps = [];

				for (var i = 0; i < this.steps.length; i++) {
					if (
						this.steps[i].test ||
						(i + 1 == this.steps.length &&
							this.tests.configuration.end)
					) {
						data = this.$refs[this.steps[i].id][0].get_data();
						if (
							!data ||
							data.length == 0 ||
							Object.keys(data[0]).length == 0
						) {
							data = self.$refs[self.steps[i].id][0].getUrls();
							//console.log("urls")
							//console.log(data)
							if (data.length > 0) {
								data = await treatments.getFileAlyx(
									data[0].url,
									false,
									false
								);
								data = this.$papa.parse(data, { header: true });
								data = data.data;
							}
						}
						test.steps.push({
							step: clone(this.steps[i]),
							data: clone(data),
						});
					}
				}

				self.$nextTick(async function () {
					for (var i = 0; i < test.steps.length; i++) {
						self.$refs[
							"tabulator" + idx + test.steps[i].step.data["uid"]
						][0].load(test.steps[i].data);
					}
				});
			},
			async start_test(idx) {
				var self = this;
				var test = this.tests.tests[idx];
				this.initial_method = "fichier";

				this.test_id = idx;
				test.color = "orange";
				test.nb = 0;

				for (var j = 0; j < test.steps.length; j++) {
					test.steps[j].test_data = [];
					test.steps[j].diff = {
						nb_lines: 0,
					};
					self.$refs[
						"tabulator" +
							idx +
							test.steps[j].step.data["uid"] +
							"result"
					][0].load([]);
				}

				self.$nextTick(async function () {
					await self.$refs.start_tabulator.load(test.start_data);
					var step = self.steps[self.steps.length - 1];
					self.$refs[step.id][0].test(true);
				});
			},
			async test_step(idx, step, step_id) {
				//console.log("test_step")
				if (step.test) {
					var self = this;
					var test = this.tests.tests[idx];

					for (var i = 0; i < test.steps.length; i++) {
						if (step.data.uid == test.steps[i].step.data.uid) {
							var data =
								self.$refs[
									self.steps[step_id].id
								][0].get_data();
							//console.log(clone(data))
							if (
								!data ||
								data.length == 0 ||
								Object.keys(data[0]).length == 0
							) {
								data =
									self.$refs[
										self.steps[step_id].id
									][0].getUrls();
								//console.log("urls")
								//console.log(data)
								if (data.length > 0) {
									data = await treatments.getFileAlyx(
										data[0].url,
										false,
										false
									);
									//console.log(data)
									data = this.$papa.parse(data, {
										header: true,
									});
									//console.log(data)
									data = data.data;
									//console.log(data)
								}
							}
							test.steps[i].test_data = clone(data);
							self.$refs[
								"tabulator" + idx + step.data.uid + "result"
							][0].load(test.steps[i].test_data);

							step = test.steps[i];
							step.diff = {
								nb: 0,
								nb_lines: 0,
							};
							data = step.data;
							var data_test = step.test_data;

							//console.log(step)

							step.diff.nb_lines = data.length - data_test.length;
							if (step.diff.nb_lines != 0) step.diff.nb++;

							var keys = [];
							var columns =
								data.length > 0 ? Object.keys(data[0]) : [];
							var columns_test =
								data_test.length > 0
									? Object.keys(data_test[0])
									: [];

							step.diff.columns_less = [];
							step.diff.columns_more = [];

							for (var j = 0; j < columns.length; j++) {
								if (!columns_test.includes(columns[j]))
									step.diff.columns_less.push(columns[j]);
								else keys.push(columns[j]);
							}

							if (step.diff.columns_less.length > 0)
								step.diff.nb++;

							for (var j = 0; j < columns_test.length; j++) {
								if (!columns.includes(columns_test[j]))
									step.diff.columns_more.push(
										columns_test[j]
									);
							}

							if (step.diff.columns_more.length > 0)
								step.diff.nb++;

							var max = data.length;
							if (data_test.length < data.length)
								max = data_test.length;
							step.diff.data = [];
							for (var j = 0; j < max; j++) {
								var obj = {};
								var diff = 0;
								for (var k = 0; k < keys.length; k++) {
									obj[keys[k]] = data[j][keys[k]];
								}
								for (var k = 0; k < keys.length; k++) {
									if (
										data[j][keys[k]] !=
										data_test[j][keys[k]]
									) {
										obj[keys[k]] +=
											" | " + data_test[j][keys[k]];
										diff++;
									}
								}
								if (diff) step.diff.data.push(obj);
							}

							if (step.diff.data.length > 0) step.diff.nb++;

							self.$refs[
								"tabulator" + idx + step.step.data.uid + "diff"
							][0].load(step.diff.data);
							test.nb += step.diff.nb;

							break;
						}
					}
				}
			},
			async test_end(idx) {
				//console.log("test_end")
				var self = this;
				var test = this.tests.tests[idx];

				if (test.nb > 0) 
					test.color = "red";
				else 
					test.color = "green";
			},
			set_state(new_state) {
				this.state = new_state;
			},
			set_state_test(new_state) {
				this.state_test = new_state;
			},
			async updateTable() {
				this.$refs.start_tabulator.init(this.table);
			},
			async setColumnImport() {
				this.$refs.start_tabulator.set_data([
					this.project_data.column_import,
				]);
			},
			async update_final_data(id, data) {
				this.final_tabulator_data = data;
			},
			async make_list(data, column) {
				var self = this;
				var id = uniqueId("");
				this.listWords.push({
					id: "list-" + id,
					name: "liste " + (this.listWords.length + 1),
					list: [],
				});
                
                setTimeout(() => {
                    // console.log("Searching for list ref: ", id);
                    self.$refs["list-" + id][0].importArray(data, column);
					self.$refs["list-" + id][0].setName("liste " + this.listWords.length);
                }, 1);

				// self.$nextTick(function () {
				// 	self.$refs[id][0].importArray(data, column);
				// 	self.$refs[id][0].setName("liste " + this.listWords.length);
				// });
			},
			geProjectUid()
			{
				return this.project_uid;
			},
			getProject(name) {
				for (var i = 0; i < this.list_projects.length; i++) {
					if (
						this.list_projects[i].uid == name ||
						this.list_projects[i].libelle == name
					) {
						return this.list_projects[i];
					}
				}
				return "";
			},
			getFile(files, name) {
				for (var i = 0; i < files.length; i++) {
					if (files[i].name == name) {
						return files[i];
					}
				}
				return null;
			},
			async test_project(
				project,
				formData,
				tags,
				results_files,
				name_file,
				first_csv,
				urls,
				nb_step, 
				step,
				params,
				treatment_params,
				step_uid
			) {
				params = params;
				
				var tag_data = {};
				console.log("test_project")
				console.log(project.tags)
				console.log(tags)
				
				if (project.tags && tags) {
					for (var i = 0; i < project.tags.length; i++) {
						if (project.tags[i].tag == tags)
							tag_data = project.tags[i];
					}
				}
				var treatment_data = await treatments.create(
					project.uid,
					null,
					null,
					null,
					[tags],
					tag_data.type_import || "import",
					formData,
					params,
					treatment_params,
					step_uid
				).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });
				while (
					treatment_data.treatment.resultat != "ok" &&
					treatment_data.treatment.resultat != "ko"
				) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
					treatment_data = await treatments.get(
						treatment_data.treatment.uid
					);
				}
				var all_files = await treatments.getFiles(
					treatment_data.treatment.uid
				);
				if (!all_files || all_files.length == 0) 
					all_files = [];
				all_files.sort((a, b) =>
					a.nom_fichier > b.nom_fichier ? 1 : -1
				);
				var export_type = tag_data.type_export || "export";
				console.log(all_files)
				console.log(tag_data)
				console.log(export_type);
				for (var i = 0; i < all_files.length; i++) {
					if (nb_step <= 1 && this.render_files) {
						if (
							first_csv &&
							all_files[i].type == export_type &&
							all_files[i].nom_fichier.endsWith(".csv") &&
							!step.file_result
						) {
							var csv_data = await treatments.getFile(
								all_files[i].uid,
								all_files[i].nom_fichier,
								false,
								false
							);
							name_file = all_files[i].nom_fichier;
							this.results = this.$papa.parse(csv_data, {
								header: true,
							});
							this.results = this.results.data;
							first_csv = false;
						} else if (all_files[i].type == export_type) {
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
						}
					} else {
						if (all_files[i].type == export_type)
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
					}
				}

				return { name_file, first_csv, urls, treatment: treatment_data.treatment };
			},
			async f_stop_test()
			{
				this.stop_test = true;
			},
			async test_by_line(
				step,
				id,
				data,
				lots = false)
			{
				console.log("test_by_line");

				console.log(data);

				if (data.action == "fonction" && data.parameters.type != "line")
				{
					this.$notify({
						group: "info",
						title: "Le test ligne à ligne ne marche que pour le mode ligne pour les scripts personnalisés.",
						type: "error",
					});
					return;
				}

				this.stop_test = false;

				step.set_time("start");
				step.set_time("dowload");

				var formData = new FormData();
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != "uid")
						formData.set(
							keys[i],
							typeof data[keys[i]] === "object"
								? JSON.stringify(data[keys[i]])
								: data[keys[i]]
						);
				}

				var prev_id = null;
				var prev_nb = [];
				var prev_ids = [];
				var next_id = null;
				var current_id = null;

				if (step.source_data) {
					prev_nb = step.source_data.split("|");
					for (var i = 0; i < prev_nb.length; i++) {
						if (prev_nb[i] == "import") prev_ids.push("");
						else prev_nb[i] = parseInt(prev_nb[i]);
					}
				}

				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						current_id = i;
						if (i != 0) 
							prev_id = this.steps[i - 1].id;
						if (i + 1 < this.steps.length)
							next_id = this.steps[i + 1].id;
					}
					if (prev_nb.includes(i + 1))
						prev_ids.push(this.steps[i].id);
				}


				formData.set("sql_rules", step.getRules());
				formData.set("step_uid", step.getUid());

				if (this.user_params_test)
				{
					var user_params = this.$refs.treatment_params.get();
					formData.set("treatment_params", JSON.stringify(user_params));
				}

				var lists = {};
				for (var i = 0; i < this.listWords.length; i++) {
					if (!this.listWords[i].parameters.db) {
						var list = [];
						for (
							var j = 0;
							j < this.listWords[i].list.length;
							j++
						) {
							var words = [];
							for (
								var k = 0;
								k < this.listWords[i].list[j].words.length;
								k++
							) {
								words.push(
									this.listWords[i].list[j].words[k].text
								);
							}
							list.push(words);
						}
						lists[this.listWords[i].name] = list;
					}
				}

				formData.set("lists", JSON.stringify(lists));

				var name_file = "data.csv";
				if (prev_id !== null) {
					name_file = this.$refs[prev_id][0].get_name_file();
					data = await this.$refs[prev_id][0].get_data();
				} else {
					data = await this.$refs.start_tabulator.get_data();
				}
				data = clone(data);

				formData.append("project_uid", this.project_uid);
				formData.append("step_id", current_id + 1);

				if (this.user_params_test)
				{
					var treatment_params_config = this.$refs.treatment_params.get_load_name();
					if (treatment_params_config)
						formData.append("treatment_params_config", treatment_params_config)
				}

				var results = [];

				step.set_test_line(0, data.length);
				
				var nb = 1;
				if (lots)
					nb = this.lines_nb;
				for (var i = 0; i < data.length; i += nb)
				{
					var lines = data.slice(i, i + nb)
					var str_csv = json2csv.parse(lines, {
						fields: Object.keys(data[i]),
						fieldNames: Object.keys(data[i]),
					});

					console.log(str_csv)

					var file =
						new File([str_csv], name_file, {
							type: "text/csv",
						})
					;

					console.log(file)

					formData.append(file.name, file);

					this.results = await workers.test(formData, null, null);

					formData.delete(file.name);

					var stop = this.results.data.stop;

					this.logs = this.results.data.error;

					var all_files = this.results.data.files;
					if (!all_files || all_files.length == 0) 
						all_files = [];
					all_files.sort((a, b) => (a.name > b.name ? 1 : -1));

					console.log(all_files)
					this.results = [];

					var csv_data = await treatments.getFileAlyx(
						all_files[0].url,
						false,
						false
					);
					name_file = all_files[0].name;
					this.results = this.$papa.parse(csv_data, {
						header: true,
					});
					this.results = this.results.data;

					console.log(this.results);

					results = results.concat(this.results);
					results = tools.standardize_json_all(results);
					this.results = results;

					step.setResults(
						this.results,
						data,
						this.logs,
						[],
						name_file,
						"csv",
						[],
						[]
					);

					step.set_test_line(i + nb, data.length);

					if (this.stop_test)
					{
						break;
					}
				}

				step.set_test_line(0, 0);

				console.log("end")

				//console.log(this.results)

				step.set_time("treatment");
				step.set_time("end");

				step.set_time("upload");

				if (next_id != null) {
					this.steps[current_id + 1].prev_data = this.results;
					this.steps[current_id + 1].prev_files = [];
					this.steps[current_id + 1].prev_urls = [];
				}

				if (stop)
				{
					this.change_status(id, "stop");
				}

				return stop;

			},
			async test(
				step,
				id,
				data,
				before,
				keep_start_data,
				treatment,
				nb_step = 0,
				files_test = null,
				urls_test = null
			) {
				console.log(urls_test)
				// Enregistrer la date du dernier test éditeur (une seule fois par session)
				if (!this.first_test_done && nb_step === 0 && this.project_data && this.project_data.uid) {
					console.log("save date")
					this.first_test_done = true;
					try { await projects.recordTestDate(this.project_data.uid); } catch(e) {
						console.log(e)
					}
				}

				var formData = new FormData();
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != "uid")
						formData.set(
							keys[i],
							typeof data[keys[i]] === "object"
								? JSON.stringify(data[keys[i]])
								: data[keys[i]]
						);
				}

				var prev_id = null;
				var prev_nb = [];
				var prev_ids = [];
				var next_id = null;
				var current_id = null;

				if (step.source_data) {
					prev_nb = step.source_data.split("|");
					for (var i = 0; i < prev_nb.length; i++) {
						if (prev_nb[i] == "import") prev_ids.push("");
						else prev_nb[i] = parseInt(prev_nb[i]);
					}
				}

				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						current_id = i;
						if (i != 0) 
							prev_id = this.steps[i - 1].id;
						if (i + 1 < this.steps.length)
							next_id = this.steps[i + 1].id;
					}
					if (prev_nb.includes(i + 1))
						prev_ids.push(this.steps[i].id);
				}

				if (before === true) {
					if (prev_id)
					{
						let stop = await this.test(
							this.$refs[prev_id][0],
							this.$refs[prev_id][0].get_id(),
							this.$refs[prev_id][0].get_params_data(),
							true,
							this.$refs[prev_id][0].get_keep_start_data(),
							this.$refs[prev_id][0].get_treatment(),
							nb_step + 1
						);
					if (stop)
						return stop;
					}
				}

				formData.set("sql_rules", step.getRules());
				formData.set("step_uid", step.getUid());

				if (this.user_params_test)
				{
					var user_params = this.$refs.treatment_params.get();
					formData.set("treatment_params", JSON.stringify(user_params));
				}

				var lists = {};
				for (var i = 0; i < this.listWords.length; i++) {
					if (!this.listWords[i].parameters.db) {
						var list = [];
						for (
							var j = 0;
							j < this.listWords[i].list.length;
							j++
						) {
							var words = [];
							for (
								var k = 0;
								k < this.listWords[i].list[j].words.length;
								k++
							) {
								words.push(
									this.listWords[i].list[j].words[k].text
								);
							}
							list.push(words);
						}
						lists[this.listWords[i].name] = list;
					}
				}

				formData.set("lists", JSON.stringify(lists));

				this.results = [];

				var results_file = null;
				var results_files = [];
				var name_file = "";
				var type_result = "csv";

				var files = [];
				var urls = [];
				if (files_test)
				{
				}
				else if (urls_test)
				{
					urls = urls_test;
				}
				else
				{
					if (prev_ids.length == 0) {
						if (prev_id !== null) {
							urls = this.$refs[prev_id][0].getUrls();
						}
					} else {
						for (var i = 0; i < prev_ids.length; i++) {

							if (prev_ids[i] !== "")
							{
								urls = urls.concat(
									this.$refs[prev_ids[i]][0].getUrls()
								);
							}
						}
					}
				}

				console.log(urls)

				var browser = false;

				if (this.browser && !files_test && this.initial_method != "fichiers" && urls.length == 0 && prev_ids.length == 0 &&
					(data.action == "fonction"
					|| data.action == "sequence"
					|| data.action == "rules"
					|| data.action == "fusionner lignes"
					|| data.action == "split_json"
					|| data.action == "supprimer lignes"
					|| data.action == "nettoyage"
					|| data.action == "blacklist_whitelist"
					|| data.action == "conversion"
					|| data.action == "split"
					|| data.action == "deux points"
					|| data.action == "chercher et classer"
					|| data.action == "chercher et remplacer"
					|| data.action == "mapping colonnes"
					|| data.action == "mapping colonnes - fichier cible"
					|| data.action == "opérations sur colonnes"
					|| data.action == "capitalize"
					|| data.action == "doublons"
					|| data.action == "referentiel"
					|| data.action == "fonctions excel"
					|| data.action == "mapping"))
				{
					var name_file = "data.csv";
					if (prev_id !== null) {
						name_file = this.$refs[prev_id][0].get_name_file();
						data = await this.$refs[prev_id][0].get_data();
					} else {
						data = await this.$refs.start_tabulator.get_data();
					}
					data = clone(data);

					var params = await workers.get_params(formData);

					var columns = [];
					if (data.length > 0)
						columns = Object.keys(data[0]);

					if (params.browser == false || data.length * columns.length > 100000)
					{
						formData.append("name", params.name)
						formData.append("body", JSON.stringify(params.body))
					}
					else
					{
						browser = true;
						
						step.set_time("start");
						step.set_time("dowload");
						try
						{
							var result = await workers.execute(params.name, params.body, data);
							this.results = result.data;
							this.logs = result.errors || [];
							step.set_time("treatment");
							step.set_time("end");
							console.log("end treatment csv");
						}
						catch (err)
						{
							this.results = data;
							step.set_time("error");
							console.log(err)
							this.logs = [err];
						}

						step.setResults(
							this.results,
							data,
							this.logs,
							[],
							name_file,
							type_result,
							[],
							[]
						);

						if (result && result.stop)
						{
							this.change_status(id, "stop");
							return true;
						}
					}

				}

				if (browser == false)
				{

					if (files_test)
					{
						files = files_test;
					}
					else if (urls_test)
					{
					}
					else
					{
						if (prev_ids.length == 0) {
							if (prev_id !== null) {
								files = await this.$refs[prev_id][0].get_data_files();
							} else {
								files =
									await this.$refs.start_tabulator.get_data_files();
							}
						} else {
							for (var i = 0; i < prev_ids.length; i++) {

								if (prev_ids[i] !== "")
								{
									var fs = [];

									fs = await this.$refs[prev_ids[i]][0].get_data_files();
									files = files.concat(fs);
								}
								else {
									files =
										await this.$refs.start_tabulator.get_data_files();
								}
							}
						}
					}

					//console.log(urls)
					//console.log(files)

					var url_files = urls;
					if (urls.length > 0 && !treatment)
						formData.set("url_files", JSON.stringify(urls));

					step.set_time("start");

					var stop = false;

					var urls = [];

					if (!treatment) {

						for (var i = 0; i < files.length; i++) {
							formData.append(files[i].name, files[i]);
						}

						formData.append("project_uid", this.project_uid);
						formData.append("step_id", current_id + 1);

						if (this.user_params_test)
						{
							var treatment_params_config = this.$refs.treatment_params.get_load_name();
							if (treatment_params_config)
								formData.append("treatment_params_config", treatment_params_config)
						}

						/*for (var pair of formData.entries()) {
							console.log(pair[0]+ ', ' + pair[1]); 
						}*/

						this.results = await workers.test(formData, step, null);

						//console.log(this.results)

						stop = this.results.data.stop;

						this.logs = this.results.data.error;

						var all_files = this.results.data.files;
						if (!all_files || all_files.length == 0) all_files = [];
							all_files.sort((a, b) => (a.name > b.name ? 1 : -1));

						//console.log(all_files)
						this.results = [];

						var first_csv = true;
						for (var i = 0; i < all_files.length; i++) {
							if (nb_step <= 1 && this.render_files) {
								if (
									first_csv &&
									all_files[i].name.endsWith(".csv") &&
									!step.file_result
								) {
									var csv_data = await treatments.getFileAlyx(
										all_files[i].url,
										false,
										false
									);
									name_file = all_files[i].name;
									this.results = this.$papa.parse(csv_data, {
										header: true,
									});
									this.results = this.results.data;
									var first_csv = false;
								} else {
									//console.log("other type file");
									urls.push({
										name: all_files[i].name,
										url: all_files[i].url,
									});
								}
							} else {
								urls.push({
									name: all_files[i].name,
									url: all_files[i].url,
								});
							}
						}
					} else {
						console.log(url_files)
						for (var i = 0; i < url_files.length; i++)
						{
							var file = await treatments.getFileAlyx(url_files[i].url, false);
							file = new File([file],url_files[i].name);
							files.push(file);
						}
						var urls = [];
						var first_csv = true;
						step.set_time("dowload");
						if (data.parameters.csv) 
						{
							var conditions = [{
								"name": "sql",
								"sql": data.sql_rules
							}];
			                var cond = new Condition();
							var default_project = this.getProject(data.parameters.project);

							var projectsCsv = {
								"": {
										lines: [],
										project: null,
									}
							};
							console.log(files)
							for (var i = 0; i < files.length; i++) {
								if (files[i].name.endsWith(".csv")) {
									var data_csv = await this.parse_file(files[i]);
									data_csv = this.$papa.parse(data_csv, {
										header: true,
									});
									data_csv = data_csv.data;
									console.log(data_csv)
									console.log(conditions)
									for (var j = 0; j < data_csv.length; j++) {
										console.log(data_csv[j]);
										console.log(data.parameters.column_project)
										var project = default_project
										if (data.parameters.column_project && data_csv[j][data.parameters.column_project])
											project = this.getProject(data_csv[j][data.parameters.column_project]);
										var tag = data.parameters.column_tags ? data_csv[j][data.parameters.column_tags] : "";
										if (!conditions || conditions.length == 0 || !cond.test(data_csv[j], conditions))                
										{
											if (!projectsCsv[project.uid + " " + tag]) 
											{
												projectsCsv[project.uid + " " + tag] =
													{
														lines: [],
														project: project,
														tag: tag,
														file: [],
														file_name: [],
													};
											}
											projectsCsv[project.uid + " " + tag].lines.push(data_csv[j]);
										}
										else
											projectsCsv[""].lines.push(data_csv[j]);
									}
								}
							}
							console.log(projectsCsv)
							var keys = Object.keys(projectsCsv);
							console.log(keys)
							for (var i = 0; i < keys.length; i++) {
								if (keys[i])
								{
									console.log("project " + keys[i])
									console.log(projectsCsv[keys[i]].lines)

									var str_csv = json2csv.parse(projectsCsv[keys[i]].lines, {
										fields: Object.keys(projectsCsv[keys[i]].lines.length > 0 ? projectsCsv[keys[i]].lines[0] : []),
										fieldNames: Object.keys(projectsCsv[keys[i]].lines.length > 0 ? projectsCsv[keys[i]].lines[0] : []),
									});

									formData.append("data - " + projectsCsv[keys[i]].project.libelle + ".csv", 
										new File([str_csv], "data - " + projectsCsv[keys[i]].project.libelle + ".csv", {
											type: "text/csv",
										})
									);

									var resp = await this.test_project(
										projectsCsv[keys[i]].project,
										formData,
										data.parameters.tags,
										results_files,
										name_file,
										first_csv,
										urls,
										nb_step,
										step,
										data.parameters || {},
										this.user_params_test ? user_params : [],
										step.getUid()
									);

									console.log("response project")
									console.log(resp)
									if (resp.treatment.resultat == "ko")
									{
										stop = true;
										this.logs = resp.treatment.details.error;
									}

									console.log(clone(resp))
									name_file = resp.name_file;
									first_csv = resp.first_csv
									formData.delete("data - " + projectsCsv[keys[i]].project.libelle + ".csv");
								}
								else if (projectsCsv[keys[i]].lines.length > 0)
								{
									console.log("no project")
									console.log(projectsCsv[keys[i]].lines)
									name_file = "data.csv";
									first_csv = false;
									this.results = projectsCsv[keys[i]].lines;
								}
							}
						}
						else if (data.parameters.column_project) {
							var projectsCsv = {};
							console.log(files)
							for (var i = 0; i < files.length; i++) {
								if (files[i].name.endsWith(".csv")) {
									var data_csv = await this.parse_file(files[i]);
									data_csv = this.$papa.parse(data_csv, {
										header: true,
									});
									data_csv = data_csv.data;
									console.log(data_csv)
									for (var j = 0; j < data_csv.length; j++) {
										var project = this.getProject(data_csv[j][data.parameters.column_project]);
										var tag = data.parameters.column_tags ? data_csv[j][data.parameters.column_tags] : "";
										if (project) 
										{
											if (!projectsCsv[project.uid + " " + tag]) 
											{
												projectsCsv[project.uid + " " + tag] =
													{
														project: project,
														tag: tag,
														file: [],
														file_name: [],
													};
											}
											var file = await treatments.getFileAlyx(data_csv[j][data.parameters.column_url], false, false);
											//console.log(file);
											var file = await treatments.getFileAlyx(data_csv[j][data.parameters.column_url],false);
											file = new File([file], data_csv[j][data.parameters.column_file]);
											//console.log(file)
											if (file && !projectsCsv[project.uid + " " + tag].file_name.includes(data_csv[j][data.parameters.column_file])) 
											{
												projectsCsv[project.uid + " " + tag].file.push(file);
												projectsCsv[project.uid + " " + tag].file_name.push(data_csv[j][data.parameters.column_file]);
											}
										}
									}
								}
							}
							console.log(projectsCsv)
							var keys = Object.keys(projectsCsv);
							for (var i = 0; i < keys.length; i++) {
								for (
									var j = 0;
									j < projectsCsv[keys[i]].file.length;
									j++
								) {
									formData.append(projectsCsv[keys[i]].file_name[j], projectsCsv[keys[i]].file[j]);
								}
								var resp = await this.test_project(
									projectsCsv[keys[i]].project,
									formData,
									data.parameters.tags,
									results_files,
									name_file,
									first_csv,
									urls,
									nb_step,
									step,
									data.parameters || {},
									this.user_params_test ? user_params : [],
									step.getUid()
								);
								
								console.log("response project")
								console.log(resp)

								if (resp.treatment.resultat == "ko")
								{
									stop = true;
									this.logs = resp.treatment.details.error;
								}
								
								name_file = resp.name_file;
								first_csv = resp.first_csv
								for (
									var j = 0;
									j < projects[keys[i]].file.length;
									j++
								) {
									formData.delete(projects[keys[i]].file_name[j]);
								}
							}
						} 
						else {
							for (var i = 0; i < files.length; i++) {
								formData.append(files[i].name, files[i]);
							}

							var project = this.getProject(data.parameters.project);
							//console.log(project)
							var resp = await this.test_project(
								project,
								formData,
								data.parameters.tags,
								results_files,
								name_file,
								first_csv,
								urls,
								nb_step,
								step,
								data.parameters || {},
								this.user_params_test ? user_params : [],
								step.getUid()
							);

							if (resp.treatment.resultat == "ko")
							{
								stop = true;
								this.logs = resp.treatment.details.error;
							}

							console.log("response project")
							console.log(resp)



							name_file = resp.name_file;
							first_csv = resp.first_csv;
							urls = resp.urls;
						}
						step.set_time("treatment");
					}

					step.set_time("upload");

					step.setResults(
						this.results,
						data.file,
						this.logs,
						results_files,
						name_file,
						type_result,
						results_file,
						urls
					);
				}
				if (next_id != null) {
					this.steps[current_id + 1].prev_data = this.results;
					this.steps[current_id + 1].prev_files = results_files;
					this.steps[current_id + 1].prev_urls = urls;
				}

				var columns = [];
				this.missing_columns = null;
				var cible_data = this.$refs.final_tabulator.get_data();

				if (this.results.length > 0 && cible_data.length > 0) {
					this.missing_columns = [];
					columns = [];
					var cible_keys = Object.keys(cible_data[0]);
					var keys = Object.keys(this.results[0]);
					for (var i = 0; i < keys.length; i++) {
						if (cible_keys.includes(keys[i])) columns.push(keys[i]);
					}
					for (var i = 0; i < cible_keys.length; i++) {
						if (!keys.includes(cible_keys[i]))
							this.missing_columns.push(cible_keys[i]);
					}
				}

				if (columns.length == 0) columns = null;

				//this.tabIndex = 1;
				if (keep_start_data)
					this.$refs.intermediate_tabulator.set_data(
						data.file,
						columns
					);
				else
					this.$refs.intermediate_tabulator.set_data(
						this.results,
						columns
					);

				if (this.test_id != null) {
					this.test_step(this.test_id, step, current_id);
				}

				if (nb_step == 0) {
					if (this.test_id != null) {
						this.test_end(this.test_id);
						this.test_id = null;
					}
				}

				if (stop)
				{
					this.change_status(id, "stop");
				}

				return stop;
			},
			async setProject(id) {
				//console.log("setProject")
				this.project_data = {};
				for (var i = 0; i < this.list_projects.length; i++) {
					if (this.list_projects[i].uid == (id ? id : this.project)) {
						//this.project_data = this.list_projects[i];
						this.project_data = await projects.get(id ? id : this.project)
						//console.log("project_data")
						//console.log(this.project_data)
					}
				}
				// If not found in list (e.g. newly created project), fetch directly
				if (!this.project_data.uid && id) {
					this.project_data = await projects.get(id) || {};
				}
			},
			async initial_database()
			{
				console.log("initial_database")
				
				if (this.editor_init)
				{
					var config = await this.$refs.initial_database.save();
					var init_data = this.editor_init.getValue();
					if (init_data["base de données"])
					{
						init_data["base de données"].params = config;
						this.editor_init.setValue(init_data);
					}
				}
			},
			async importFile() {
				var self = this;

				self.tabulator_import_data = this.$refs.start_tabulator.get_data();
				if (this.steps.length > 0) 
				{
					this.steps[0].prev_data = [];
					this.steps[0].prev_files = [];
					if (this.initial_method == "fichiers")
						this.steps[0].prev_files = await this.$refs.start_tabulator.get_data_files(false);
					else
						this.steps[0].prev_data = self.tabulator_import_data;
				}
				var fields = [];
				if (self.tabulator_import_data.length > 0)
					fields = Object.keys(self.tabulator_import_data[0]);
				if (self.tabulator_columns_data.length == 1 && self.tabulator_columns_data[0].colonne == "" && fields > 0)
					self.tabulator_columns_data = [];
				// * ici on ne supprime pas les anciens champs s'ils sont plus dans fields
				for (var i = 0; i < fields.length; i++) 
				{
					var index = -1;
					for (var j = 0; j < self.tabulator_columns_data.length; j++) 
					{
						if (self.tabulator_columns_data[j].colonne == fields[i])
							index = j;
					}
					if (index == -1)
						self.tabulator_columns_data.push({colonne: fields[i], type: "texte",});
				}

				this.importedFile = true;
			},
			addLine: function () {
				this.tabulator_columns_data.push({
					colonne: "",
					type: "texte",
				});
			},
			addList: function () {
				var self = this;

				var id = uniqueId("");
				this.listWords.push({
					id: "list-" + id,
					name: "liste " + (this.listWords.length + 1),
					list: [],
				});
				self.$nextTick(function () {
					self.$refs["list-" + id][0].setName(
						"liste " + this.listWords.length
					);
					self.$refs["list-" + id][0].import_db();
				});
			},
			removeStepDescription(description) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						this.steps.splice(i, 1);
				}
			},
			removeAt(idx) {

                // show actionchoice
                if (this.project_v2) {
                    this.toggleActionChoice(true);
                }

				this.steps.splice(idx, 1);
				this.view_step = "";
				this.view_idx = 0;
			},
			removeTestAt(idx) {
				this.tests.tests.splice(idx, 1);
			},
			removeListAt(idx) {
				this.listWords.splice(idx, 1);
			},
			updateList(id, name, list, parameters) {
				for (var i = 0; i < this.listWords.length; i++) {
					if (this.listWords[i].id == id) {
						this.listWords[i].name = name;
						this.listWords[i].list = list;
						this.listWords[i].parameters = parameters;
					}
				}
			},
			async updateStepActionByDescription(description, data, label) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						await this.$refs[this.steps[i].id][0].setAction(data, label);
				}
			},
			updateStepParametersByDescription(description, data, project_id = null) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						this.$refs[this.steps[i].id][0].update_data_parameters(data, project_id);
				}
			},
			async getStepsByDescription(description) {
				var steps = [];
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].description.includes(description))
					{	
						var step = await this.$refs[this.steps[i].id][0].save_self();
						steps.push(step);
					}
				}
				//console.log(steps);
				return steps;
			},
			existStepByDescription(description) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						return true;
				}
				return false;
			},
			deleteStepByDescription(description, start = false) {
				//console.log("deleteStepByDescription")
				//console.log(description)
				for (var i = 0; i < this.steps.length; i++) {
					if ((!start && description == this.steps[i].description) || (start && this.steps[i].description.startsWith(description)))
					{
						this.steps.splice(i, 1);
						this.view_step = "";
						this.view_idx = 0;
						i--;
					}
				}
			},
			getStepParametersByDescription(description, data) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						return this.$refs[this.steps[i].id][0].get_params_data().parameters;
				}
			},
			set_init_data(data)
			{
				this.init_data = data;
				this.editor_init.setValue(this.init_data);
			},
			addStep: async function (step, first = null, after = null) {
				//console.log(step)

				if (!this.$refs[this.view_step] || !this.$refs[this.view_step][0])
					this.view_step = ""

				if (after)
				{
					this.view_step = "";

					for (var i = 0; i < this.steps.length; i++) {
						for (var j = 0; j < after.length; j++)
						{
							if (this.steps[i].description.includes(after[j]))
							{
								this.view_step = this.steps[i].id;
								this.view_idx = i;
							}
						}
					}
				}

				var prev_urls = [];
				if (this.steps.length === 0) {
					var prev_data = this.$refs.start_tabulator.get_data();
					var prev_files =
						await this.$refs.start_tabulator.get_data_files(false);
				} else if (!this.view_step) {
					var prev_data =
						this.$refs[
							this.steps[this.steps.length - 1].id
						][0].get_data();
					var prev_files = await this.$refs[
						this.steps[this.steps.length - 1].id
					][0].get_data_files(false);
					prev_urls =
						this.$refs[
							this.steps[this.steps.length - 1].id
						][0].getUrls();
				} else {
					//console.log(this.view_step)
					var prev_data = this.$refs[this.view_step][0].get_data();
					var prev_files = await this.$refs[
						this.view_step
					][0].get_data_files(false);
					prev_urls = this.$refs[this.view_step][0].getUrls();
				}
				var id = uniqueId("");
				if (step) {
					if (after && this.view_step)
					{
						this.steps.splice(this.view_idx + 1, 0, {
							description: step.description,
							data: {},
							status: "black",
							id,
							prev_files: [],
							load_data: step,
						});
						this.view_idx++;
					}
					else if (first)
						this.steps.unshift({
							description: step.description,
							data: {},
							status: "black",
							id,
							prev_files: [],
							load_data: step,
						});
					else
						this.steps.push({
							description: step.description,
							data: {},
							status: "black",
							id,
							prev_files: [],
							load_data: step,
						});
				} else if (this.view_step === "") {
					this.steps.push({
						description: "",
						id: id,
						prev_files,
						prev_data,
						prev_urls,
						data: { action: "" },
						status: "black",
					});
					this.view_idx = this.steps.length - 1;
				} else {
					this.steps.splice(this.view_idx + 1, 0, {
						description: "",
						id: id,
						prev_files,
						prev_data,
						prev_urls,
						data: { action: "" },
						status: "black",
					});
					this.view_idx++;
				}
				this.view_step = id;
			},
			add_test: async function () {
				this.tests.tests.push({
					uid: this.$uuid.v4(),
					name: "test " + (this.tests.tests.length + 1),
					start_data: [],
					steps: [],
				});
			},
			change(id, data, steps, description, source_data="", file_result = false) {
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
                        this.steps[i].source_data = source_data;
						this.steps[i].steps = steps;
						this.steps[i].data = data;
						this.steps[i].file_result = file_result;
						// * si description est vide, on fait confiance à step-v2 d'avoir changé la description depuis l'element <stepv2>
						this.steps[i].description =
							description === ""
								? this.steps[i].description
								: description;
						// pour réactivité
						this.$set(this.steps, i, this.steps[i]);
						//console.log(this.steps[i])
						break;
					}
				}
			},
			async change_user_params()
			{
				var user_params = [];
				for (var i = 0; i < this.steps.length; i++) {
					var step = this.$refs[this.steps[i].id][0];
					user_params = user_params.concat(step.get_users_params())
				}
				this.user_params = user_params;
				await this.$refs.treatment_params.set(this.user_params);
			},
			change_errors(id, errors) {
				//console.log("change")
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						this.steps[i].errors = errors;
						// pour réactivité
						this.$set(this.steps, i, this.steps[i]);
						//console.log(this.steps[i])
						break;
					}
				}
			},
			change_status(id, status) {
				//console.log("status : " + status)
				//console.log("change status")
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						//console.log("status")
						if (
							status == "start" ||
							status == "dowload" ||
							status == "treatment"
						) {
							this.steps[i].status = "orange";
						} else if (status == "error") {
							this.steps[i].status = "red";
						} else if (status == "stop") {
							this.steps[i].status = "blue";
						} else {
							this.steps[i].status = "green";
						}
						// pour réactivité
						this.$set(this.steps, i, this.steps[i]);
						//console.log(this.steps[i])
						break;
					}
				}
			},
			onResize() {
				if (this.$refs.div_row)
					this.size =
						this.$refs.div_row.clientWidth -
						this.$refs.div_menu.clientWidth;
			},
			onResizeTest() {
				if (this.$refs.div_row_test)
					this.size_test =
						this.$refs.div_row_test.clientWidth -
						this.$refs.div_menu_test.clientWidth;
			},
		},
		created: async function () {
			if (this.state_prop) this.state = this.state_prop;
			if (this.initial_method_prop)
				this.initial_method = this.initial_method_prop;
		},
		mounted: async function () {
			this.user = store.state.user;
			if (
				this.config &&
				store.state.user.rules &&
				!store.state.user.rules.scenarios
			) {
				this.$router.push({ name: "profile" });
			}

			// Initialiser Tabulator pour l'éditeur de colonnes
			this.$nextTick(() => {
				if (this.$refs.tabulator_columns) {
					this.tabulator_columns = new Tabulator(this.$refs.tabulator_columns, {
						...this.tabulator_columns_options,
						data: this.tabulator_columns_data,
						layout: "fitData"
					});
				}
			});

			var self = this;

			this.list_projects = await projects.getAll(false, true, null, true);
			this.list_projects_archive_libelle = [];

			this.list_obj_projects_libelle = {};
			this.list_obj_projects_uid = {};
			this.list_projects_libelle = [];

			for (var i = 0; i < this.list_projects.length; i++) {
				if (this.list_projects[i].libelle) {
					this.list_obj_projects_libelle[
						this.list_projects[i].libelle
					] = this.list_projects[i].uid;
					this.list_obj_projects_uid[this.list_projects[i].uid] =
						this.list_projects[i].libelle;
					this.list_projects_libelle.push(
						this.list_projects[i].libelle
					);
				}
				if (this.list_projects[i].archive == true) {
					if (
						this.list_projects[i].details &&
						this.list_projects[i].details.scenario
					) {
						this.list_projects_archive.push(this.list_projects[i]);
						this.list_projects_archive_libelle.push(
							this.list_projects[i].libelle
						);
					}
					this.list_projects.splice(i, 1);
					i--;
				}
			}

			for (var i = 0; i < this.list_projects_archive.length; i++) {
				this.projects_archive_options.push({
					value: this.list_projects_archive[i]["uid"],
					text: this.list_projects_archive[i]["libelle"],
				});
			}

			for (var i = 0; i < this.list_projects.length; i++) {
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
			}

			for (var i = 0; i < this.list_projects.length; i++) {
				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.column_import
				)
					this.list_projects[i].column_import =
						this.list_projects[i].details.column_import;
				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.tags
				) {
					this.list_projects[i].list_tags = [""];
					this.list_projects[i].tags =
						this.list_projects[i].details.tags;
					for (
						var j = 0;
						j < this.list_projects[i].tags.length;
						j++
					) {
						if (this.list_projects[i].tags[j].scenario)
							this.list_projects[i].list_tags.push(
								this.list_projects[i].tags[j].tag
							);
					}
				}
			}

			//console.log("getby_production")

			var scenarios = await scenario.getby_production();

			if (scenarios) {
				for (var i = 0; i < scenarios.length; i++) {
					if (
						!this.list_projects_archive_libelle.includes(
							scenarios[i].libelle
						)
					)
					this.list_name.push({"text": scenarios[i].libelle, "value": scenarios[i].libelle, "description": scenarios[i].description_project, "uid": scenarios[i].uid});
				}
			}
			//console.log(this.list_name)

			this.tabulator_columns_options.rowContextMenu = [
				{
					label: "Supprimer ligne",
					action: function (e, row) {
						row.delete();
						self.tabulator_columns_data =
							self.$refs.tabulator_columns
								.getInstance()
								.getData();
					},
				},
				{
					label: "Duppliquer ligne",
					action: function (e, row) {
						self.tabulator_columns_data.push(
							Object.assign({}, row.getData())
						);
					},
				},
			];

			let response = await users.getSelf(true);
			this.client = response.client;

			this.env_list = [];

			if (this.user.env) {
				this.env_list.push({
					text: "Environnement principal",
					value: "",
				});
			}

			if (this.client.details && this.client.details.env) {
				var keys = Object.keys(this.client.details.env);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != this.user.env) {
						this.env_list.push({
							text: this.client.details.env[keys[i]].name,
							value: keys[i],
						});
					}
				}
			}

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			if (tables && tables.length > 0) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}

			this.ro = new ResizeObserver(this.onResize).observe(
				this.$refs.div_row
			);
			this.ro_test = new ResizeObserver(this.onResizeTest).observe(
				this.$refs.div_row_test
			);

			self.$nextTick(function () {
				self.size =
					self.$refs.div_row.clientWidth -
					self.$refs.div_menu.clientWidth;
				self.size_test =
					self.$refs.div_row_test.clientWidth -
					self.$refs.div_menu_test.clientWidth;
			});

			var element = document.getElementById("jsoneditor-" + this.id);

			this.editor = new JSONEditor(element, {
				schema: {
					type: "array",
					format: "table",
					title: "Tags",
					items: {
						type: "object",
						title: "Tag",
						properties: {
							name: {
								type: "string",
							},
							start: {
								type: "number",
							},
							end: {
								type: "number",
							},
						},
					},
				},
				object_background: "",
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					self.ready++;
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				var tags = self.editor.getValue();
				/*for (var i = 0; i < tags.length; i++)
				{
					if (tags[i].start)
						tags[i].type_import = tags[i].start;
					if (tags[i].end)
						tags[i].type_export = tags[i].end;
				}*/
				self.tags = tags;
			});

			var element = document.getElementById(
				"jsoneditor-action-" + this.id
			);

			this.editor_actions = new JSONEditor(element, {
				schema: {
					type: "array",
					title: "Boutons d'action",
					items: {
						type: "object",
						title: "Bouton",
						properties: {
							name: {
								title: "Nom du bouton",
								type: "string",
							},
							type: {
								title: "Type de fichier",
								type: "string",
								enum: ["xml"],
							},
							action: {
								title: "Action",
								type: "string",
								enum: ["ftp"],
							},
							folder: {
								type: "string",
								title: "Dossier",
							},
							project: {
								title: "Projet",
								type: "string",
								enum: this.list_projects_libelle,
								default: "",
							},
							project_uid: {
								type: "string",
								options: { hidden: true },
							},
						},
					},
				},
				object_background: "",
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			await new Promise((resolve, reject) => {
				self.editor_actions.on("ready", function () {
					self.ready++;
					if (resolve) resolve();
				});
			});

			this.editor_actions.on("change", function () {
				self.treatment_actions = self.editor_actions.getValue();
				for (var i = 0; i < self.treatment_actions.length; i++) {
					if (self.treatment_actions[i].project)
						self.treatment_actions[i].project_uid =
							self.list_obj_projects_libelle[
								self.treatment_actions[i].project
							];
					else self.treatment_actions[i].project_uid = "";
				}
			});



			var element = document.getElementById(
				"jsoneditor-init-data-" + this.id
			);

			this.editor_init = new JSONEditor(element, {
				schema: {
					type: "object",
					title: "Données initiales",
					properties: {
						fichiers: {
							type: "object",
							title: "Fichiers",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: true
								},
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								},
								type: {
									type: "string",
									title: "Format des fichiers (ex: .csv,.txt)",
								},
								at_least_one_file: {
									type: "boolean",
									title: "Au moins 1 fichier requis",
									format: "checkbox"
								}
							}
						},
						fichiers_url: {
							type: "object",
							title: "Fichiers - url",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								},
								type: {
									type: "string",
									title: "Format des fichiers (ex: .csv,.txt)",
								},
								at_least_one_file: {
									type: "boolean",
									title: "Au moins 1 fichier requis",
									format: "checkbox"
								}
							}
						},
						documents: {
							type: "object",
							title: "Documents",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								},
								folder: {
									type: 'string',
									title: "Dossier"
								},
								extension: {
									type: 'string',
									title: "Extension"
								},
								id_prefix: {
									type: ["boolean", 'string'],
									title: "Préfixer les fichiers de l'id"
								}
							}
						},
						fichier: {
							type: "object",
							title: "Fichier CSV",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								},
								init: {
									type: 'array',
									format: "table",
									title: "Valeurs initiales",
									items: {
										type: "object",
										title: "Ligne",
										additionalProperties: {
											type: "string"
										}
									}
								}
							}
						},
						"base de données": {
							type: "object",
							title: "Base de données",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								},
								table: {
									type: "string",
									title: "Table par défaut"
								},
								params: {
									"options": {
										"collapsed": true
									},
									type: ["object", "null"],
									default: null
								}
							}
						},
						"base de données multitables": {
							type: "object",
							title: "Base de données multitables",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								}
							}
						},
						no: {
							type: "object",
							title: "Pas de données initiales",
							properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								},
							}
						},
            "google_sheet": {
              type: "object",
              title: "Google Sheet",
              properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								}
							}
            },
            "airtable": {
              type: "object",
              title: "Airtable",
              properties: {
								active: {
									type: "boolean",
									title: "Actif",
									format: "checkbox",
									default: false
								},								
								default: {
									type: "boolean",
									title: "Type par défaut",
									format: "checkbox",	
								}
							}
            },
					}
				},
				object_background: "",
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			await new Promise((resolve, reject) => {
				self.editor_init.on("ready", function () {
					self.ready++;
					if (resolve) resolve();
				});
			});

			this.editor_init.on("change", function () {
				self.init_data = self.editor_init.getValue();
			});

			if (this.$route.params.id)
			{
				var sc = await scenario.getby_id(this.$route.params.id);
				if (sc && sc.length > 0)
				{
					this.active_watch = false;
					this.load_name = sc[0].libelle;
					this.load_version = sc[0].version;
					await this.load_db();
					this.active_watch = true;
				}
			}
		},
	};
</script>

<style scoped>
	.margin_projet {
		margin-top: -1rem;
	}

	.bouton {
		margin-block-end: 2px;
	}

	/* Supprimer les fonds gris/blanc de Tabulator */
	:deep(.tabulator) {
		background-color: transparent !important;
		border: none !important;
	}

	:deep(.tabulator .tabulator-footer) {
		background-color: transparent !important;
		border: none !important;
	}

	:deep(.tabulator .tabulator-paginator) {
		background-color: transparent !important;
	}
</style>
